webpackJsonp([1],{

/***/ "/Se+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Suc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EoUh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d537ae3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("SU9I")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-7d537ae3"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b14104b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("/Se+")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef52442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("/Suc")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a70983b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("bMw6")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a9212cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("EoUh")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Escrime XXI N⁰. 112",
  "shortTitle": "",
  "description": "",
  "width": 1532,
  "height": 1149,
  "currentLanguage": "FR",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://escrime-xxi.fie.org/112/en"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://escrime-xxi.fie.org/112/fr"
  }, {
    "code": "ES",
    "text": "Spanish",
    "href": "http://escrime-xxi.fie.org/112/es"
  }],
  "basePath": "/112/fr",
  "companyLogo": "1-numeral.png",
  "publishURL": "http://escrime-xxi.fie.org/112/fr/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "mobileSwitch": true,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n\n        <img id=\"1-0\" class=\"halfScale\" style=\"top:1px;left:371px\" src=\"/112/fr/static/_content/1-numeral.png\">\n        \n        <img id=\"1-1\" class=\"halfScale\" style=\"top:98px;left:55px\" src=\"/112/fr/static/_content/1-title.png\">\n        <img id=\"1-2\" class=\"halfScale\" style=\"top:276px;left:68px\" src=\"/112/fr/static/_content/1-sub-1.png\">\n\n        <img id=\"1-3\" class=\"halfScale\" style=\"top:111px;left:1076px\" src=\"/112/fr/static/_content/1-issue.png\">\n\n        <img id=\"1-text-1\" class=\"halfScaleR pointer\" style=\"top:352px;right:0px\" onclick=\"Publish.goToPage(19)\" src=\"/112/fr/static/_content/1-sub-2.png\">\n        <img id=\"1-text-2\" class=\"halfScaleR pointer\" style=\"top:517px;right:0px\" onclick=\"Publish.goToPage(8)\" src=\"/112/fr/static/_content/1-sub-3.png\">\n        <img id=\"1-text-3\" class=\"halfScaleR pointer\" style=\"top:730px;right:0px\" onclick=\"Publish.goToPage(16)\" src=\"/112/fr/static/_content/1-sub-4.png\">\n\n        <img id=\"1-4\" class=\"halfScale pointer\" style=\"top:988px;left:1442px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/1-arrow.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n          .fromTo(idOf(\"1-1\"), 0.8, {x: -300, opacity:0}, {x: 0, opacity: 1}, 0.5)\n          .fromTo(idOf(\"1-0\"), 0.5, {x: -300, opacity:0}, {x: 0, opacity: 1, ease: Back.easeOut.config(1.7)},\"-=0.2\")\n          .fromTo(idOf(\"1-2\"), 0.5, {x: -30, opacity:0}, {x: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-3\"), 0.5, {y: 30, opacity:0}, {y: 0, opacity:1},\"-=0.2\")\n          .fromTo(idOf(\"1-text-1\"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-2\"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-text-3\"), 0.6, {x:200, opacity:0}, {x:0,  opacity:1}, \"-=0.2\")\n          .fromTo(idOf(\"1-4\"), 0.5, {x:-60, opacity:0}, {x:0, opacity:1})\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "N˚112 MAGAZINE NUMÉRIQUE  FÉDÉRATION INTERNATIONALE D’ESCRIME  JOURNÉE MONDIALE DE L’ESCRIME L’ESCRIME VÉTÉRAN AU CAIRE SOFYA VELIKAYA RETOUR AU SOMMET  Utilisez les flèches de votre clavier ou balayez l’écran avec le doigt pour naviguer horizontalement dans le magazine",
    "mobileHtml": "\n      \n      <img src=\"/112/fr/static/_mobile/pg1.jpg\">\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n\n      <img class=\"halfScale 2-title\" style=\"top:103px;left:78px\" src=\"/112/fr/static/_content/2-title.png\">\n\n      <img class=\"halfScale 2-icons\" style=\"top:863px;left:153px\" src=\"/112/fr/static/_content/2-pop.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:864px;left:453px\" src=\"/112/fr/static/_content/2-play.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:864px;left:801px\" src=\"/112/fr/static/_content/2-soc.png\">\n      <img class=\"halfScale 2-icons\" style=\"top:864px;left:1152px\" src=\"/112/fr/static/_content/2-no.png\">\n\n      <img class=\"halfScale pointer howto-desktop\" style=\"top:125px;left:1071px;opacity:1;\" onclick=\"switchPopHowto(true)\" src=\"/112/fr/static/_content/2-desktop-btn.png\">\n      <img class=\"halfScale pointer howto-ipad\" style=\"top:125px;left:1271px;opacity:0\" onclick=\"switchPopHowto(false)\" src=\"/112/fr/static/_content/2-ipad-btn.png\">\n\n      <img class=\"halfScale howto-desktop\" style=\"top:257px;left:72px;\" src=\"/112/fr/static/_content/2-desktop.png\">\n      <img class=\"halfScale howto-ipad\" style=\"top:247px;left:86px;display:none;\" src=\"/112/fr/static/_content/2-ipad.png\">\n\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": " \n        function onPageEnter() {\n          pg2Anim = new TimelineMax()\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .staggerFromTo(cOf(\"2-icons\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, onComplete: addContentLinks}, 0.3, \"-=0.2\")\n        }\n\n        function switchPopHowto(bool){\n          if(bool){\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-ipad\")[0].style.opacity = 0;\n              cOf(\"howto-ipad\")[1].style.display = \"none\";\n            }});\n            cOf(\"howto-desktop\")[0].style.opacity = 1;\n            cOf(\"howto-desktop\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:1});\n          }else{\n            cOf(\"howto-ipad\")[0].style.opacity = 1;\n            cOf(\"howto-ipad\")[1].style.display = \"block\";\n            TweenMax.to(cOf(\"howto-ipad\"), 0.5, {opacity:1});\n            TweenMax.to(cOf(\"howto-desktop\"), 0.5, {opacity:0, onComplete:function(){\n              cOf(\"howto-desktop\")[0].style.opacity = 0;\n              cOf(\"howto-desktop\")[1].style.display = \"none\";\n            }});\n          }\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "C OMMENT NAVIGUER  Cliquez pour changer d’affichage  COMMENT NAVIGUER  IPAD  BUREAU  Escrime XXI Le magazine de l’escrime utilise les toutes dernières technologies numériques. Voici quelques-unes de ses caractéristiques les plus séduisantes.  NAVIGATION Utilisez les flèches de votre pavé numérique pour vous déplacer horizontalement à travers le magazine.  Navigation Pour voir le magazine, utilisez les flèches de votre pavé numérique pour naviguer horizontalement.  BROWSER Pour de meilleurs résultats, nous recommandons d’utiliser les navigateurs Safari ou Google Chrome.  EXPLOREZ  térieur ! Des articles passionnants à l’in  1 2 3 FENÊTRES CONTEXTUELLES  BOUTON DE LECTURE  MÉDIAS SOCIAUX  NOMBRES  Appuyez pour faire surgir des trésors d’information.  Ce magazine propose de superbes vidéos, que l’on peut voir en appuyant sur ce bouton.  Appuyez sur les icones des réseaux sociaux que vous rencontrerez tout au long du magazine.  Appuyez sur les boutons pour dévoiler plus de contenus passionnants.  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n          <a href=\"http://www.tissotwatches.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:24px;right:40px;width:280px; height:30px;\"></div>\n          </a>",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.tissotwatches.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg3.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n\n        <a href=\"http://www.fie.org\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n        </a>\n\n        <div class=\"addContentLink\" style=\"top: 191px; left:80px;width:145px; height: 35px;\">\n          <a href=\"http://www.fie.org\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top: 75px; right:623px;width:55px; height: 55px;\">\n          <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLink\" style=\"top:130px; right:623px;width:55px; height: 55px;\">\n          <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\"></a></div> \n\n        <img id=\"4-title\" class=\"halfScale\" style=\"top:63px;left:86px\" src=\"/112/fr/static/_content/4-title.png\">\n\n        <img id=\"fourIpad\" class=\"cont-item-0-link halfScale\" style=\"top:386px;left:591px\" src=\"/112/fr/static/_content/4-ipad.png\">\n        <img class=\"cont-item cont-item-1-btn halfScale\" style=\"top:327px;left:573px;opacity:0\" src=\"/112/fr/static/_content/4-editorial.png\">\n        <img class=\"cont-item cont-item-2-btn halfScale\" style=\"top:338px;left:574px;opacity:0\" src=\"/112/fr/static/_content/4-sport.png\">\n        <img class=\"cont-item cont-item-3-btn halfScale\" style=\"top:358px;left:573px;opacity:0\" src=\"/112/fr/static/_content/4-interview.png\">\n        <img class=\"cont-item cont-item-4-btn halfScale\" style=\"top:351px;left:573px;opacity:0\" src=\"/112/fr/static/_content/4-fie.png\">\n        <img class=\"cont-item cont-item-5-btn halfScale\" style=\"top:327px;left:574px;opacity:0\" src=\"/112/fr/static/_content/4-news.png\">\n        <img class=\"cont-item cont-item-6-btn halfScale\" style=\"top:358px;left:574px;opacity:0\" src=\"/112/fr/static/_content/4-obit.png\">\n\n        <img id=\"4-next\" class=\"halfScale pointer\" style=\"top:940px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/4-arrow.png\">\n\n        <div class=\"addContentLink\" onclick=\"contentsBub(1);\" style=\"top:358px; left:84px; width: 492px; height: 60px;\"></div> \n        <div class=\"addContentLink\" onclick=\"contentsBub(2);\" style=\"top:450px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(3);\" style=\"top:543px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(4);\" style=\"top:635px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(5);\" style=\"top:727px; left:84px; width: 492px; height: 60px;\"></div>\n        <div class=\"addContentLink\" onclick=\"contentsBub(6);\" style=\"top:819px; left:84px; width: 492px; height: 60px;\"></div>\n\n        <div class=\"contentLink cont-item-1-link\" onclick=\"Publish.goToPage(6)\" style=\"top:357px;left:577px;width:638px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(8)\" style=\"top:358px;left:651px;width:716px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-2-link\" onclick=\"Publish.goToPage(11)\" style=\"top:450px;left:575px;width:792px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-3-link\" onclick=\"Publish.goToPage(16)\" style=\"top:541px;left:574px;width:597px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(19)\" style=\"top:357px;left:646px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(23)\" style=\"top:449px;left:646px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(27)\" style=\"top:540px;left:646px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(30)\" style=\"top:633px;left:573px;width:758px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(33)\" style=\"top:725px;left:646px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-4-link\" onclick=\"Publish.goToPage(36)\" style=\"top:816px;left:646px;width:685px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-1');}, 200)\" style=\"top:450px;left:649px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-2');}, 200)\" style=\"top:541px;left:649px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-3');}, 200)\" style=\"top:632px;left:649px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-4');}, 200)\" style=\"top:726px;left:574px;width:780px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-5-link\" onclick=\"Publish.goToPage(40); setTimeout(function(){showOverlay('40-pop-5');}, 200)\" style=\"top:817px;left:649px;width:706px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(43); setTimeout(function(){pg43Toggle('43-pop-1', '43-btn-1');}, 200)\" style=\"top:634px;left:584px;width:413px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(43); setTimeout(function(){pg43Toggle('43-pop-2', '43-btn-2');}, 200)\" style=\"top:726px;left:584px;width:413px;height:64px;display:none;\"></div>\n        <div class=\"contentLink cont-item-6-link\" onclick=\"Publish.goToPage(43); setTimeout(function(){pg43Toggle('43-pop-3', '43-btn-3');}, 200)\" style=\"top:818px;left:574px;width:424px;height:64px;display:none;\"></div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n        \n        pg4Anim.fromTo(idOf(\"4-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1}, 0.5)\n        .fromTo(idOf(\"4-next\"), 0.5, {x:-200, opacity:0}, {x:0, opacity:1, ease: Sine.easeOut, onComplete: addContentLinks},\"-=0.2\")\n      }\n  \n  \n      function contentsBub(index){\n        TweenMax.to(cOf(\"cont-hide\"), 0.5, {opacity:0})\n        console.log(\"contentsBub\", index)\n        for(var i=0; i <= 6; i++){\n          if(i == index){\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n              console.log(c)\n              c.style.display = \"\";\n            },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:1, onComplete:function(){\n              \n              classc(\"cont-item-\"+index+\"-link\")[0].style.display = \"\"\n              if(classc(\"cont-item-\"+index+\"-link\")[1]){\n                classc(\"cont-item-\"+index+\"-link\")[1].style.display = \"\" \n              }\n            }});\n          }else{\n            [].slice.call(cOf(\"cont-item-\"+i+\"-link\")).reduce(function(p,c){\n                c.style.display = \"none\";\n              },0);\n            TweenMax.to(cOf(\"cont-item-\"+i+\"-btn\"), 0.5, {opacity:0});\n            TweenMax.to(idOf(\"fourIpad\"), 0.5, {opacity:0});\n          }\n        }\n      }\n  \n      function onPageLeave() {\n        pg4Anim.stop()\n        removeContentLinks();\n        contentsBub(0);\n        TweenMax.to(idOf('fourIpad'), 0.1, {opacity:1});\n      }\n      ",
    "searchText": "SOMMAIRE  DANS CE NUMÉRO WWW.FIE.ORG  Bienvenue dans la dernière édition d’Escrime XXI, proposant les meilleures images, vidéos et articles sur l’escrime, le tout dans une éblouissante nouvelle maquette.  ÉDITORIAL  SPORT  Cliquez pour faire apparaître les détails  INTERVIEW ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES  ACTUALITÉS  NÉCROLOGIE  W W W.FIE .ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      \n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n      <img class=\"halfScale pointer 5-arrow\" style=\"top:854px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/5-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:54px\" src=\"/112/fr/static/_content/5-social-tw.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:124px\" src=\"/112/fr/static/_content/5-social-fb.png\">\n      </a>\n      <a href=\"https://www.youtube.com/user/FIEvideo\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:1013px;left:192px\" src=\"/112/fr/static/_content/5-social-yt.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"bottom:242px;left:745px;width:100px;height:26px;\">\n        <a href=\"mailto:info@fie.ch\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"bottom:213px;left:686px;width:105px;height:26px;\">\n          <a href=\"http://www.fie.org\" target=\"_blank\"></a>\n      </div>\n        <div class=\"addContentLink\" style=\"bottom:127px;right:332px;width:193px;height:30px;\">\n          <a href=\"http://www.touchline.com\" target=\"_blank\"></a>\n      </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg5Anim = new TimelineMax()\n          pg5Anim.fromTo(cOf(\"5-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg5Anim.stop()\n          removeContentLinks()\n        }\n      ",
    "searchText": "C OMITÉ E XÉCUTIF DE L A FIE  Président: Alisher Usmanov (RUS) Secrétaire Général: Emmanuel Katsiadakis (M.H.) (GRE) Secrétaire Trésorier: Ferial Nadira Salhi (ALG)  SIÈGE DE LA FIE Directrice générale Nathalie Rodriguez M.-H. (FRA)  Vice-Présidents: Ana Pascu (M.H.) (ROU) Donald Anthony (USA) Yuki Ota (JPN) Membres: Erika Aze (LAT) Jacek Bierkowski (POL) Velichka Hristeva (BUL) Isabelle Lamour (FRA) Novak Perovic (RSA) Oleg Peskov (KAZ) Giorgio Scarso (ITA) Bence Szabo (HUN) Pascal Tesch (LUX) Wei Wang (CHN) Aldo Montano Président de la Commission des Athlètes de la FIE (ITA)  Administration Directrice administrative: Elena Murdaca (ITA) Directrice de la comptabilité: Sandra Baroni (SUI) Assistante de la directrice: Gabrielle Meylan (BRA) Assistante administrative: Ylenia Murdaca (ITA) Directrice d’opérations: Elena Huot (RUS)  Président de la Confédération Africaine d’Escrime: Mbagnick Ndiaye (SEN) Président de la Confédération Panaméricaine d’Escrime: Vitaly Logvin (MEX) Président de la Confédération Asiatique d’Escrime: Celso L. Dayrit (M.H.) (PHI) Président de la Confédération Européenne d’Escrime: Stanislav Pozdnyakov (RUS) Président de la Confédération Océanique d’Escrime: Helen Smith (M.H.) (AUS)  Official Publication of the FIE International Fencing Federation Head-office of the FIE Maison du Sport International Avenue de Rhodanie 54 CH-1007 Lausanne  Tél. : +41 21 320 31 15 Fax : +41 21 320 31 16 e-mail : info@fie.ch www.fie.org  Sport Directeur sport et technique: Evgeny Tsoukhlo (RUS) Manager de la technologie et de l’administration du sport: Natalia Bodrova (RUS) Manager des operations sportives: Sophie Treyvaud (SUI) Communication, Marketing, TV Chef du cabinet du Président : Nina Lalovic (SRB) Manager digital et communication: Maria Ntanou (GRE) Responsable de la production télévisuelle de la FIE: Barna Heder (HUN) Assistante du responsable de la production télévisuelle de la FIE: Svetlana Krasnokoutskaya (RUS) Attaché de presse: Serge Timacheff (USA) Photographie: Augusto Bizzi (ITA) Design Touchline (www.touchline.com)  W W W.FIE .ORG",
    "mobileHtml": "\n      <p>\n      <b>President</b>:<br> Alisher Usmanov (RUS)<br>\n      <b>Secretary General</b>:<br> Emmanuel Katsiadakis (M.H.) (GRE)<br>\n      <b>Secretary Treasurer</b>:<br> Ferial Nadira Salhi (ALG)</p>\n      <p>\n      <b>Vice Presidents</b>:<br>\n      Ana Pascu (M.H.) (ROU)<br>\n      Donald Anthony (USA)<br>\n      Yuki Ota (JPN)<br></p>\n      <p>\n      <b>Members</b>:<br>\n      Erika Aze (LAT)<br>\n      Jacek Bierkowski (POL)<br>\n      Velichka Hristeva (BUL)<br>\n      Isabelle Lamour (FRA)<br>\n      Novak Perovic (RSA)<br>\n      Oleg Peskov (KAZ)<br>\n      Giorgio Scarso (ITA)<br>\n      Bence Szabo (HUN)<br>\n      Pascal Tesch (LUX)<br>\n      Wei WANG (CHN)<br>\n      Aldo Montano President of the FIE athletes commission (ITA)<br></p>\n\n      <p>\n        <b>President, African Fencing Confederation</b>: <br>Mbagnick Ndiaye (SEN) <br>\n        <b>President, Pan-American Fencing Confederation</b>: <br>Vitaly Logvin (MEX) <br>\n        <b>President, Asian Fencing Confederation</b>: <br>Celso L. Dayrit (M.H.) (PHI) <br>\n        <b>President, European Fencing Confederation</b>: <br>Stanislav Pozdnyakov (RUS)<br>\n        <b>President, Oceanian Fencing Confederation</b>: <br>Helen Smith (M.H.) (AUS)<br>\n      </p>\n      \n      <h2>FIE Head Office</h2>\n      <p>\n      <b>Chief Executive Officer</b><br>\n      Nathalie Rodriguez M.-H. (FRA)\n      </p>\n\n      <h2>Administration</h2>\n      <p>\n      <b>Administration Director</b>:<br> Elena Murdaca (ITA)<br>\n      <b>Accounting Manager</b>:<br> Sandra Baroni (BUL) <br>\n      <b>Assistant to the Director</b>:<br> Gabrielle Meylan (BRA)<br>\n      <b>Administrative Assistant</b>:<br> Ylenia Murdaca (ITA)<br>\n      <b>Head of Operations</b>:<br> Elena Huot (RUS)<br>\n      </p>\n\n      <h2>Sport</h2>\n      <p>\n      <b>Sport and Technical Director</b>:<br> Evgeny Tsoukhlo (RUS)<br>\n      <b>Sport Technology and Administration Manager</b>:<br> Natalia Bodrova (RUS)<br>\n      <b>Sport Operation Manager</b>:<br>Sophie Treyvaud (SUI) <br>\n      </p>\n      <h2>Communication, Marketing, TV</h2>\n      <p>\n      <b>Head of FIE President's Cabinet</b>:<br> Nina Lalovic (SRB)<br>\n      <b>Digital Communications Manager</b>:<br> Maria Ntanou (GRE)<br>\n      <b>Head of FIE TV Production</b>:<br> Barna Heder (HUN) <br>\n      <b>FIE TV Production Assistant</b>:<br> Svetlana Krasnokoutskaya (RUS)<br>\n      <b>Press Officer</b>:<br> Serge Timacheff (USA)<br>\n      <b>Photographer</b>:<br> Augusto Bizzi (ITA)<br>\n      </p>\n\n      <h2>Design</h2>\n      <p>\n      Touchline </b><br>\n      (<a href=\"http://www.touchline.com\" target=\"blank\">www.touchline.com</a>)\n      </p>\n    "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n      <a href=\"https://tokyo2020.fie.org/qualification\" target=\"_blank\">\n          <div class=\"contentLinkNone fw-pg-2\" style=\"display:none; z-index: 999; bottom:234px;right:787px;width:430px; height:30px;\"></div>\n      </a>\n\n        <img id=\"6-img\" class=\"halfScale\" style=\"top:338px;left:459px\" src=\"/112/fr/static/_content/6-img.jpg\">\n        <img id=\"6-title\" class=\"halfScale\" style=\"top:721px;left:91px\" src=\"/112/fr/static/_content/6-title.png\">\n\n        <img id=\"6-text-1\" class=\"halfScale\" style=\"top:340px;left:784px\" src=\"/112/fr/static/_content/6-text-1.png\">\n        <img id=\"6-text-2\" class=\"halfScale\" style=\"top:338px;left:201px; opacity:0;\" src=\"/112/fr/static/_content/6-text-2.png\">\n\n        <img id=\"6-cta-1\" class=\"halfScale pointer\" style=\"top:819px;left:783px\" onclick=\"toggleText6(false);\" src=\"/112/fr/static/_content/6-page-1.jpg\">\n        <img id=\"6-cta-2\" class=\"halfScale pointer\" style=\"top:819px;left:1062px;opacity:0\" onclick=\"toggleText6(true);\" src=\"/112/fr/static/_content/6-page-2.jpg\">\n\n        <img id=\"6-next\" class=\"halfScale pointer\" style=\"top:938px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/6-arrow.jpg\">\n      ",
    "script": "\n      function onPageEnter(){\n        pg6Anim = new TimelineMax();\n        pg6Anim.fromTo(idOf(\"6-img\"), 0.5,{opacity:0}, {opacity:1},0.5)\n            .fromTo(idOf(\"6-title\"), 0.3,{x:-100,opacity:0}, {x:0,opacity:1},\"-=0.2\")\n            .fromTo(idOf(\"6-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1,onComplete:addContentLinks},\"+=0.3\")\n      }\n\n      function toggleText6(bool){\n        var text1 = idOf(\"6-text-1\");\n        var text2 = idOf(\"6-text-2\");\n        \n        if(!bool && text1.style.opacity == \"0\"){\n          pg6Anim.play();\n          TweenMax.fromTo(text1, 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(text2, 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:0}, {opacity:1});\n        }else if(bool && text2.style.opacity == \"0\"){\n          pg6Anim.pause();\n          TweenMax.fromTo(text1, 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(text2, 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-cta-1\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-cta-2\"), 0.5, {opacity:0}, {opacity:1});\n          TweenMax.fromTo(idOf(\"6-img\"), 0.5, {opacity:1}, {opacity:0});\n          TweenMax.fromTo(idOf(\"6-title\"), 0.5, {opacity:1}, {opacity:0});\n          cOf(\"fw-pg-2\")[0].style.display = 'block';\n        }\n      }\n\n      function onPageLeave(){\n        if(idOf(\"6-text-1\").style.opacity == \"0\"){\n          toggleText6(false);\n        }\n        pg6Anim.stop();\n        removeContentLinks()\n      }\n      ",
    "searchText": "SOMMAIRE  Chers amis,  L’ESCRIME POUR UNE PLANÈTE PLUS PROPRE ET VERTE  Après une saison 2019 très réussie et l’effervescence des Championnats du monde de Budapest, nous avons mis le cap sur une grande célébration de la Journée mondiale de l’escrime en septembre. Nos tireurs, clubs d’escrime et fédérations se sont mobilisés dans 153 pays pour faire découvrir notre sport et plus important encore, pour mettre leurs talents et leur dévouement envers le sport au service de l’épanouissement de leurs communautés et de l’amélioration de notre environnement commun.  PAGE 1  PAGE 2  W W W.FIE .ORG",
    "mobileHtml": "\n      \n      \n\n      \n\n      \n\n      \n\n      \n\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/6-img.jpg\">\n      <p>Apr\xE8s une saison 2019 tr\xE8s r\xE9ussie et l'effervescence des Championnats du monde de Budapest, nous avons mis le cap sur une grande c\xE9l\xE9bration de la Journ\xE9e mondiale de l'escrime en septembre. Nos tireurs, clubs d'escrime et f\xE9d\xE9rations se sont mobilis\xE9s dans 153 pays pour faire d\xE9couvrir notre sport et plus important encore, pour mettre leurs talents et leur d\xE9vouement envers le sport au service de l'\xE9panouissement de leurs communaut\xE9s et de l'am\xE9lioration de notre environnement commun.</p>\n      <p>Le mois d'octobre a \xE9t\xE9 marqu\xE9 par un autre grand \xE9v\xE9nement de l'escrime, r\xE9serv\xE9 cette fois \xE0 nos tireurs les plus \xE2g\xE9s : les Championnats du monde d'escrime v\xE9t\xE9rans 2019 au Caire. Vingt-quatre \xE9preuves dans trois cat\xE9gories d'\xE2ge (50+, 60+ et 70+) ont ainsi \xE9t\xE9 disput\xE9es par 699 athl\xE8tes des cinq continents et rediffus\xE9es int\xE9gralement en direct sur Internet pour la toute premi\xE8re fois.</p>\n      <p>Vingt-six comp\xE9titions satellites avec un tr\xE8s bon taux de participation ont d\xE9j\xE0 \xE9t\xE9 organis\xE9es au cours de cette p\xE9riode automnale pour pr\xE9parer la saison senior. Tous nos athl\xE8tes ont aujourd'hui les yeux riv\xE9s sur Tokyo 2020 et notre processus de qualification olympique qui se terminera en avril prochain et que vous pouvez d\xE9couvrir sur notre portail \xAB Tokyo Loves Fencing \xBB \xE0 l'adresse https://tokyo2020.fie.org/qualification.</p>\n      <p>Le voyage se poursuit avec l'ouverture prochaine de cette saison olympique par la Coupe du monde d'\xE9p\xE9e f\xE9minine de Tallinn en Estonie. Avec un enjeu de taille, 284 tireurs inscrits en individuel et 29 \xE9quipes en lice, cette comp\xE9tition donne le coup d'envoi d'une autre grande saison d'escrime internationale.</p>\n      <p>Je vous remercie de votre participation et de votre soutien \xE0 la FIE, et de faire partie de notre communaut\xE9 de l'escrime v\xE9ritablement mondiale. </p>\n      <br>\n      <p>Alisher Usmanov</p>\n      <p><strong>Pr\xE9sident de la FIE</strong></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <div class=\"contentLink\" style=\"top:962px;left:769px;width:719px; height:54px;\">\n          <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.absolutefencinggear.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg7.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 8-title\" style=\"top:125px;left:350px\" src=\"/112/fr/static/_content/8-title.png\">\n\n      <img class=\"halfScale 8-line\" style=\"top:307px;left:869px\" src=\"/112/fr/static/_content/8-line.png\">\n\n      <img class=\"halfScale 8-sub\" style=\"top:301px;left:911px\" src=\"/112/fr/static/_content/8-sub.png\">\n\n      <img class=\"halfScale pointer 8-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/8-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax()\n          pg8Anim.fromTo(cOf(\"8-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"8-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"8-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop()\n        }\n      ",
    "searchText": "CHAMPIONNATS DU MONDE VÉ TÉR ANS  CHAMPIONNATS DU MONDE D'ESCRIME VÉTÉRANS LE CAIRE, ÉGYPTE 5 AU 11 OCTOBRE 2019",
    "mobileHtml": "\n        <h2>Championnats du monde d'escrime v\xE9t\xE9rans</h2>\n        <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg8.jpg\">\n        <p><b>LE CAIRE, \xC9gypte<br>\n          5 au 11 octobre 2019<br>\n        </b></p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 9-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax()\n          pg9Anim\n            .fromTo(cOf(\"9-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop()\n        }\n      ",
    "searchText": "CHAMPIONNATS DU MONDE VÉTÉRANS LE CAIRE, ÉGYPTE 2/3  Les Championnats du monde d'escrime vétérans du Caire se sont terminés après sept jours de compétition en individuel et par équipes passionnants qui ont réuni 699 tireurs de plus de 50 ans venus des cinq continents. La compétition, organisée dans les salles couvertes du Cairo Stadium Indoor Halls Complex, comprenait au total 24 épreuves au fleuret, à l'épée et au sabre. Les USA sont arrivés en tête du tableau des médailles avec six médailles d'or, suivis de la GrandeBretagne et de l'Italie, avec toutes deux quatre médailles d'or ; au total, 13 pays ont remporté au moins une médaille.",
    "mobileHtml": "\n\n      \n       \n      \n\n      <p>Les Championnats du monde d'escrime v\xE9t\xE9rans du Caire se sont termin\xE9s apr\xE8s sept jours de comp\xE9tition en individuel et par \xE9quipes passionnants qui ont r\xE9uni 699 tireurs de plus de 50 ans venus des cinq continents. La comp\xE9tition, organis\xE9e dans les salles couvertes du Cairo Stadium Indoor Halls Complex, comprenait au total 24 \xE9preuves au fleuret, \xE0 l'\xE9p\xE9e et au sabre. Les USA sont arriv\xE9s en t\xEAte du tableau des m\xE9dailles avec six m\xE9dailles d'or, suivis de la Grande-Bretagne et de l'Italie, avec toutes deux quatre m\xE9dailles d'or ; au total, 13 pays ont remport\xE9 au moins une m\xE9daille. </p>\n      <p>En 2019, 46 f\xE9d\xE9rations des cinq r\xE9gions continentales \xE9taient repr\xE9sent\xE9es, et les \xE9preuves ont \xE9t\xE9 supervis\xE9es par des arbitres de la FIE appartenant \xE0 neuf f\xE9d\xE9rations distinctes. C'est la seconde fois que les Championnats du monde v\xE9t\xE9rans sont accueillis en Afrique. En 1997, une d\xE9monstration d'\xE9p\xE9e masculine v\xE9t\xE9ran avait \xE9t\xE9 organis\xE9e lors des Championnats du monde d'escrime seniors au Cap, Afrique du Sud.</p>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 10-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/10-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-red.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('10-pop')\" style=\"top:855px;left:59px\" src=\"/112/fr/static/_content/trophy-red.png\">\n\n      <div id=\"10-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/10-pop-bg.png\">\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC halfpulse animatedpulse\" style=\"top:969px;left:833px\" src=\"/112/fr/static/_content/10-trophy.png\">\n        </a>\n        <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 166px; height: 49px;opacity:0\" onclick=\"hideOverlay('10-pop');\"></div>\n        <img id=\"10-sabre\" class=\"halfScale 10-events\" style=\"top:302px;left:269px;opacity:1\" src=\"/112/fr/static/_content/10-pop-1.png\">\n        <img id=\"10-foil\" class=\"halfScale 10-events\" style=\"top:394px;left:269px; opacity:0\" src=\"/112/fr/static/_content/10-pop-2.png\">\n        <img id=\"10-epee\" class=\"halfScale 10-events\" style=\"top:421px;left:269px; opacity:0\" src=\"/112/fr/static/_content/10-pop-3.png\">\n\n        <div class=\"contentLink\" style=\"top:303px;left:269px;height:217px;width:113px;\" onclick=\"toggleCategory('10-sabre', '10-events')\" src=\"/112/fr/static/_content/10-pop-1.png\"></div>\n        <div class=\"contentLink\" style=\"top:525px;left:269px;height:217px;width:113px;\" onclick=\"toggleCategory('10-foil', '10-events')\" src=\"/112/fr/static/_content/10-pop-2.png\"></div>\n        <div class=\"contentLink\" style=\"top:747px;left:269px;height:217px;width:113px;\" onclick=\"toggleCategory('10-epee', '10-events')\" src=\"/112/fr/static/_content/10-pop-3.png\"></div>\n\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax()\n          pg10Anim\n            .fromTo(cOf(\"10-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop()\n          hideOverlay('10-pop');\n        }\n      ",
    "searchText": "CHAMPIONNATS DU MONDE VÉTÉRANS LE CAIRE, ÉGYPTE 3/3  Cliquez ici pour voir les MÉDAILLÉS D'OR  En 2019, 46 fédérations des cinq régions continentales étaient représentées, et les épreuves ont été supervisées par des arbitres de la FIE appartenant à neuf fédérations distinctes. C'est la seconde fois que les Championnats du monde vétérans sont accueillis en Afrique. En 1997, une démonstration d'épée masculine vétéran avait été organisée lors des Championnats du monde d'escrime seniors au Cap, Afrique du Sud. ■  W W W.FIE .ORG",
    "mobileHtml": "\n      \n      <h2>M\xE9daill\xE9s d'or</h2>\n      <p><strong>Tableau des m\xE9daill\xE9s d'or des Championnats du monde d'escrime v\xE9t\xE9rans 2019:</strong></p>\n\n      <br>\n\n      <p><strong>OCT 5-7 2019</strong></p>\n\n      <br>\n\n      <p><strong>Sabre</strong></p>\n      <p>Octobre 5</p>\n      <p>Femmes\tIndividuel\tDorothea Tanzmeister (AUT)</p>\n      <p>Femmes\tIndividuel\tLydia Mazarol (USA)</p>\n      <p>Femmes\tIndividuel\tSilvia Brown (GBR)</p>\n      <p>Hommes\tIndividuel\tRiccardo Carmina (ITA)</p>\n\n      <br>\n\n      <p><strong>Sabre</strong></p>\n      <p>Octobre 6</p>\n     <p>Hommes\tIndividuel\tMark Lundborg (USA)</p>\n      <p>Hommes\tIndividuel\tJoshua Runyan (USA)</p>\n      <p>Femmes\tPar \xE9quipes\t\tGrande-Bretagne</p>\n\n      <p><strong>Fleuret</strong></p>\n      <p>Octobre 7</p>\n      <p>Femmes\tIndividuel\tInessa Rodionova (RUS)</p>\n      <p>Femmes\tIndividuel\tJenette Starks-Faulkner (USA)</p>\n      <p>Femmes\tIndividuel\tMarja-Liisa Tuulikki Someroja (FIN)</p>\n      \n      <p><strong>Sabre</strong></p>\n      <p>Hommes\tPar \xE9quipes\t\tItalie</p>\n\n      <br>\n\n      <p><strong>OCT 8-9 2019</strong></p>\n\n      <br>\n\n      <p><strong>Fleuret</strong></p>\n      <p>Octobre 8</p>\n      <p>Hommes\tIndividuel\tChristian Dousse (SUI)</p>\n      <p>Hommes\tIndividuel\tPaul Wedge (GBR)</p>\n      <p>Hommes\tIndividuel\tBrian Causton (GBR)</p>\n      <p>Femmes\tPar \xE9quipes\t\tRussie</p>\n\n      <p><strong>\xC9p\xE9e</strong></p>\n      <p>Octobre 9</p>\n      <p>Femmes\tIndividuel\tDorothea Tanzmeister (AUT)</p>\n      <p>Femmes\tIndividuel\tElizabeth Kocab (USA)</p>\n      <p>Hommes\tIndividuel\tGeorg Schmidt-Thomes (GER)</p>\n      \n      <p><strong>Fleuret</strong></p>\n      <p>Hommes\tPar \xE9quipes\t\tItalie</p>\n\n      <br>\n\n      <p><strong>OCT 10-11 2019</strong></p>\n\n      <br>\n\n\n      <p><strong>\xC9p\xE9e</strong></p>\n      <p>Octobre 10</p>\n      <p>Hommes\tIndividuel\tMichel Guy (FRA)</p>\n      <p>Hommes\tIndividuel\tRichard Purdie (AUS)</p>\n      <p>Femmes\tPar \xE9quipes\t\tMarja-Liisa Tuulikki Someroja (FIN)</p>\n\n      <br>\n\n      <p><strong>\xC9p\xE9e</strong></p>\n      <p>Octobre 11</p>\t\n      <p>Femmes\tPar \xE9quipes\t\tItalie</p>\n      <p>Hommes\tPar \xE9quipes\t\tUSA</p>\n\n\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 11-title\" style=\"top:96px;left:86px\" src=\"/112/fr/static/_content/11-title.png\">\n\n      <img class=\"halfScale 11-line\" style=\"top:256px;left:929px\" src=\"/112/fr/static/_content/11-line.png\">\n\n      <img class=\"halfScale 11-sub\" style=\"top:250px;left:972px\" src=\"/112/fr/static/_content/11-sub.png\">\n\n      <img class=\"halfScale pointer 11-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/8-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg11Anim = new TimelineMax()\n          pg11Anim.fromTo(cOf(\"11-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"11-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"11-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"11-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop()\n        }\n      ",
    "searchText": "CHAMPIONNATS DU MONDE EN FAUTEUIL ROUL ANT  CHAMPIONNATS DU MONDE D'ESCRIME EN FAUTEUIL CHEONGJU, CORÉE DU SUD ROULANT DE L’IWAS 17 AU 23 SEPTEMBRE 2019",
    "mobileHtml": "\n      \n      <h2>Championnats du monde d'escrime en fauteuil roulant de l\u2019IWAS </h2>\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg11.jpg\">\n      <p><strong>CHEONGJU, COR\xC9E DU SUD</strong></p>\n      <p><strong>17 au 23 septembre 2019</strong></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 12-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/8-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-red.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax()\n          pg12Anim\n            .fromTo(cOf(\"12-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop()\n        }\n      ",
    "searchText": "CHAMPIONNATS DU MONDE EN FAUTEUIL ROULANT CHEONGJU, CORÉE DU SUD 2/3  Les escrimeurs chinois ont raflé 11 des 22 médailles d’or en jeu lors des Championnats du monde d'escrime en fauteuil roulant 2019 à Cheongju, en Corée du sud, en s’imposant dans les épreuves par équipe et en individuel, à l’épée, au fleuret et au sabre. Des épreuves étaient organisées dans les trois catégories paralympiques : A, B et C (selon le degré de handicap de l’athlète, la catégorie C désignant le handicap le plus sévère).* Plusieurs moments remarquables et passionnants ont pu être relevés lors de cette compétition des Championnats du monde. Le Chinois Shumei Tan s’est révélé être un concurrent de taille ; il a décroché des médailles d’or aussi bien au sabre qu’à l’épée dans la catégorie B, alors que cela ne fait qu’un peu plus d’un an qu’il a fait ses premiers pas dans le monde de l’escrime. La championne italienne paralympique de 22 ans, Beatrice Vio, a remporté sa troisième victoire consécutive au fleuret Dames dans la catégorie B, et les médaillés paralympiques Jianquan Tian, Xufeng Zou, Jing Rong, Yenke Feng et Jing Bian ont également rapporté des médailles d’or à la Chine.",
    "mobileHtml": "\n      \n\n\n\n\n\n\n\n\n\n      <p>Les escrimeurs chinois ont rafl\xE9 11 des 22 m\xE9dailles d\u2019or en jeu lors des Championnats du monde d'escrime en fauteuil roulant 2019 \xE0 Cheongju, en Cor\xE9e du sud, en s\u2019imposant dans les \xE9preuves par \xE9quipe et en individuel, \xE0 l\u2019\xE9p\xE9e, au fleuret et au sabre. Des \xE9preuves \xE9taient organis\xE9es dans les trois cat\xE9gories paralympiques : A, B et C (selon le degr\xE9 de handicap de l\u2019athl\xE8te, la cat\xE9gorie C d\xE9signant le handicap le plus s\xE9v\xE8re).*</p>\n      <p>Plusieurs moments remarquables et passionnants ont pu \xEAtre relev\xE9s lors de cette comp\xE9tition des Championnats du monde. Le Chinois Shumei Tan s\u2019est r\xE9v\xE9l\xE9 \xEAtre un concurrent de taille ; il a d\xE9croch\xE9 des m\xE9dailles d\u2019or aussi bien au sabre qu\u2019\xE0 l\u2019\xE9p\xE9e dans la cat\xE9gorie B, alors que cela ne fait qu\u2019un peu plus d\u2019un an qu\u2019il a fait ses premiers pas dans le monde de l\u2019escrime. La championne italienne paralympique de 22 ans, Beatrice Vio, a remport\xE9 sa troisi\xE8me victoire cons\xE9cutive au fleuret Dames dans la cat\xE9gorie B, et les m\xE9daill\xE9s paralympiques Jianquan Tian, Xufeng Zou, Jing Rong, Yenke Feng et Jing Bian ont \xE9galement rapport\xE9 des m\xE9dailles d\u2019or \xE0 la Chine. La Hongrie s\u2019est impos\xE9e dans l\u2019\xE9preuve de fleuret Dames par \xE9quipe face \xE0 Hong Kong d\u2019une seule touche (score final de 45 \xE0 44) et, lors de l\u2019\xE9preuve individuelle de sabre Hommes, le russe Alexander Kurzin est reparti avec la m\xE9daille d\u2019or qu\u2019il convoitait tant apr\xE8s neuf ann\xE9es de tournois internationaux et six Championnats du monde.</p>\n      <p>Les Championnats du monde d'escrime en fauteuil roulant de l\u2019IWAS 2019 constituent un tournoi essentiel pour la pr\xE9paration des Jeux Paralympiques de Tokyo en 2020. Tous les r\xE9sultats sont disponibles ici. </p>\n      <p>Vous avez \xE9galement la possibilit\xE9 de regarder la comp\xE9tition \xE0 la demande sur la cha\xEEne YouTube de l\u2019IWAS.</p>\n      <p>La prochaine \xE9preuve sera la derni\xE8re Coupe du Monde d\u2019escrime en fauteuil roulant de l\u2019IWAS de l\u2019ann\xE9e, qui se tiendra \xE0 Amsterdam, aux Pays-Bas, du 14 au 17 novembre.</p>\n      <p>*Les \xE9preuves de sabre Hommes et Dames dans la cat\xE9gorie C n\u2019ont pas eu lieu, et les r\xE9sultats des \xE9preuves \xE9p\xE9e et fleuret Dames dans la cat\xE9gorie C ont \xE9t\xE9 consid\xE9r\xE9s comme non officiels, avec trois tireurs dans chaque \xE9preuve.</p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 13-arrow\" style=\"top:845px;left:1387px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/10-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-red.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-red.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n      <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:581px;left:1103px;width:34px; height:30px;\"></div>\n      </a>\n\n      <a href=\"https://www.youtube.com/channel/UCTnzFhDigJXhORjkBFAAihg\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:702px;left:840px;width:206px; height:30px;\"></div>\n      </a>\n\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('13-pop')\" style=\"top:855px;left:59px\" src=\"/112/fr/static/_content/trophy-red.png\">\n\n      <div id=\"13-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/13-pop.png\">\n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <img class=\"halfScaleC halfpulse animatedpulse\" style=\"top:969px;left:837px\" src=\"/112/fr/static/_content/10-trophy.png\">\n        </a>\n        <div class=\"contentLink\" style=\"top: 85px; left: 1343px; width: 167px; height: 49px;opacity:0\" onclick=\"hideOverlay('13-pop');\"></div>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax()\n          pg13Anim\n            .fromTo(cOf(\"13-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onClick: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg13Anim.stop()\n          hideOverlay('13-pop');\n          removeConentLinks();\n        }\n      ",
    "searchText": "CHAMPIONNATS DU MONDE EN FAUTEUIL ROULANT CHEONGJU, CORÉE DU SUD 3/3  La Hongrie s’est imposée dans l’épreuve de fleuret Dames par équipe face à Hong Kong d’une seule touche (score final de 45 à 44) et, lors de l’épreuve individuelle de sabre Hommes, le Russe Alexander Kurzin est reparti avec la médaille d’or qu’il convoitait tant après neuf années de tournois internationaux et six Championnats du monde. Les Championnats du monde d'escrime en fauteuil roulant de l’IWAS 2019 constituent un tournoi essentiel pour la préparation des Jeux Paralympiques de Tokyo en 2020. Tous les résultats sont disponibles ici. Vous avez également la possibilité de regarder la compétition à la demande sur la chaîne YouTube de l’IWAS. La prochaine épreuve sera la dernière Coupe du Monde d’escrime en fauteuil roulant de l’IWAS de l’année, qui se tiendra à Amsterdam, aux Pays-Bas, du 14 au 17 novembre.  Cliquez ici pour voir les MÉDAILLÉS D'OR  Les épreuves de sabre Hommes et Dames dans la catégorie C n’ont pas eu lieu, et les résultats des épreuves épée et fleuret Dames dans la catégorie C ont été considérés comme non officiels, avec trois tireurs dans chaque épreuve. ■ *  W W W.FIE .ORG",
    "mobileHtml": "\n      \n      <p><strong>INDIVIDUEL</strong></p>\n\n      <br>\n\n      <p><strong>Cat\xE9gorie A</strong></p>\n      <p>\xC9p\xE9e masculine\t\t\tPiers Gilliver (GBR)</p>\n      <p>\xC9p\xE9e f\xE9minine\t\t\tXufeng Zou (CHN)</p>\n      <p>Fleuret masculin\t\t\tLiqiang Chen (CHN)</p>\n      <p>Fleuret f\xE9minin\t\t\tJing Rong (CHN)</p>\n      <p>Sabre masculin\t\t\tJianquan Tian (CHN)</p>\n      <p>Sabre f\xE9minin\t\t\tJing Bian (CHN)</p>\n\n      <br>\n\n      <p><strong>Cat\xE9gorie B</strong></p>\n      <p>\xC9p\xE9e masculine\t\t\tDimitri Coutya (GBR)</p>\n      <p>\xC9p\xE9e f\xE9minine\t\t\tShumei Tan (CHN)</p>\n      <p>Fleuret masculin\t\t\tYanke Feng (CHN)</p>\n      <p>Fleuret f\xE9minin\t\t\tBeatrice Maria Vio (ITA)</p>\n      <p>Sabre masculin\t\t\tAlexander Kurzin (RUS)</p>\n      <p>Sabre f\xE9minin\t\t\tShumei Tan (CHN)</p>\n\n      <br>\n\n      <p><strong>Cat\xE9gorie C</strong></p>\n      <p>\xC9p\xE9e masculine\t\t\tSerhii Shavkun (UKR)</p>\n      <p>\xC9p\xE9e f\xE9minine (unofficial)\tConsuelo Nora (ITA)</p>\n      <p>Fleuret masculin\t\t\tNikolay Lukyanov (RUS)</p>\n      <p>Fleuret f\xE9minin (unofficial)\tHann Pashkova (UKR)</p>\n      <p>Sabre masculin\t\t\ts/o</p>\n      <p>Sabre f\xE9minin\t\t\ts/o</p>\n\n      <br>\n\n      <p><strong>\xC9QUIPE</strong></p>\n\n      <br>\n\n      <p>\xC9p\xE9e masculine\t\t\tRussie</p>\n      <p>\xC9p\xE9e f\xE9minine\t\t\tChine</p>\n      <p>Fleuret masculin\t\t\tChine</p>\n      <p>Fleuret f\xE9minin\t\t\tHongrie</p>\n      <p>Sabre masculin\t\t\tUkraine</p>\n      <p>Sabre f\xE9minin\t\t\tChine</p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      \n      <svg class=\"abs pulse animatedpulse pointer\" onclick=\"Publish.openVideo('/112/fr/static/_content/11-vid.m4v')\" style=\"bottom:460px;left:1146px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n        <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n      </svg>\n\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.allstar.de\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg14.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n          <a href=\"https://www.blaise-freres.fr\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"bottom:331px;right:1053px;width:256px; height:30px;\"></div>\n          </a>",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/112/fr/static/_mobile/pg15.jpg\">\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 16-title\" style=\"top:20px;left:71px\" src=\"/112/fr/static/_content/16-no.png\">\n\n      <img class=\"halfScale 16-name-1\" style=\"top:656px;left:-353px\" src=\"/112/fr/static/_content/16-title-1.png\">\n      <img class=\"halfScale 16-name-2\" style=\"top:773px;left:272px\" src=\"/112/fr/static/_content/16-title-2.png\">\n\n      <img class=\"halfScale pointer 16-arrow\" style=\"top:949px;left:1409px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/16-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax()\n          pg16Anim\n            .fromTo(cOf(\"16-title\"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1},0.5)\n            .fromTo(cOf(\"16-name-1\"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1},\"-=0.2\")\n            .fromTo(cOf(\"16-name-2\"), 0.4,{x:200,opacity:0}, {x:0,opacity:1},\"-=0.1\")\n            .fromTo(cOf(\"16-arrow\"), 0.4,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, \"-=0.1\")\n        }\n\n        function onPageLeave() {\n          pg16Anim.stop()\n        }\n      ",
    "searchText": "À L A RENC ONTRE DES SP ORTIFS  			 SOFYA 					VELIKAYA",
    "mobileHtml": "\n      \n      <h2>\xC0 LA RENCONTRE DES SPORTIFS</h2>\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg16.jpg\">\n      <p><strong>Sofya Velikaya (RUS)</strong></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n      <img id=\"17-img-1\" class=\"17-questions\" style=\"top:18px;left:20px\" src=\"/112/fr/static/_content/17-img-1.jpg\">\n      <img id=\"17-img-2\" class=\"17-questions\" style=\"top:18px;left:20px; display: none;\" src=\"/112/fr/static/_content/17-img-2.jpg\">\n      <img id=\"17-img-3\" class=\"17-questions\" style=\"top:18px;left:20px; display: none;\" src=\"/112/fr/static/_content/17-img-3.jpg\">\n      <img id=\"17-img-4\" class=\"17-questions\" style=\"top:18px;left:20px; display: none;\" src=\"/112/fr/static/_content/17-img-4.jpg\">\n      <img id=\"17-img-5\" class=\"17-questions\" style=\"top:18px;left:20px; display: none;\" src=\"/112/fr/static/_content/17-img-5.jpg\">\n      <img id=\"17-img-6\" class=\"17-questions\" style=\"top:18px;left:20px; display: none;\" src=\"/112/fr/static/_content/17-img-6.jpg\">\n      <img id=\"17-img-7\" class=\"17-questions\" style=\"top:18px;left:20px; display: none;\" src=\"/112/fr/static/_content/17-img-7.jpg\">\n\n      <img id=\"17-no-1\" class=\"halfScale 17-questions\" style=\"top:417px;left:729px\" src=\"/112/fr/static/_content/17-1.png\">\n      <img id=\"17-no-2\" class=\"halfScale 17-questions\" style=\"top:417px;left:730px; display: none;\" src=\"/112/fr/static/_content/17-2.png\">\n      <img id=\"17-no-3\" class=\"halfScale 17-questions\" style=\"top:417px;left:729px; display: none;\" src=\"/112/fr/static/_content/17-3.png\">\n      <img id=\"17-no-4\" class=\"halfScale 17-questions\" style=\"top:417px;left:729px; display: none;\" src=\"/112/fr/static/_content/17-4.png\">\n      <img id=\"17-no-5\" class=\"halfScale 17-questions\" style=\"top:417px;left:729px; display: none;\" src=\"/112/fr/static/_content/17-5.png\">\n      <img id=\"17-no-6\" class=\"halfScale 17-questions\" style=\"top:417px;left:729px; display: none;\" src=\"/112/fr/static/_content/17-6.png\">\n      <img id=\"17-no-7\" class=\"halfScale 17-questions\" style=\"top:417px;left:729px; display: none;\" src=\"/112/fr/static/_content/17-7.png\">\n\n      <div class=\"addContentLink\" style=\"top: 443px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('17-no-1', '17-img-1')\"></div>\n      <div class=\"addContentLink\" style=\"top: 538px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('17-no-2', '17-img-2')\"></div>\n      <div class=\"addContentLink\" style=\"top: 629px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('17-no-3', '17-img-3')\"></div>\n      <div class=\"addContentLink\" style=\"top: 722px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('17-no-4', '17-img-4')\"></div>\n      <div class=\"addContentLink\" style=\"top: 813px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('17-no-5', '17-img-5')\"></div>\n      <div class=\"addContentLink\" style=\"top: 907px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('17-no-6', '17-img-6')\"></div>\n      <div class=\"addContentLink\" style=\"top: 1000px; left: 1382px; width: 132px; height: 97px;\" onclick=\"swapQuestion('17-no-7', '17-img-7')\"></div>\n      <img id=\"17-next\" class=\"halfScale pointer\" style=\"top:949px;left:603px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/16-arrow.png\">\n      ",
    "script": "\n      function onPageEnter() {\n        pg17Anim = new TimelineMax()\n        pg17Anim.fromTo(idOf(\"17-next\"), 0.3,{x:-200,opacity:0}, {x:0,opacity:1, onComplete: addContentLinks}, 0.5)\n      }\n\n      function swapQuestion(ele, img) {\n        var x = cOf(\"17-questions\");\n        var i;\n        for (i = 0; i < x.length; i++) {\n          x[i].style.display = 'none';\n        }\n        idOf(ele).style.display = \"\"\n        idOf(img).style.display = \"\"\n      }\n\n      function onPageLeave() {\n        pg17Anim.stop()\n        removeContentLinks()\n      }\n      ",
    "searchText": "La Russe Sofya Velikaya, actuellement N°2 mondiale au sabre, est l'une des tireuses les plus accomplies de l'histoire : septuple championne du monde, deux fois en individuel et cinq fois par équipes, elle a également remporté sept titres en Grand Prix. Nous lui avons posé quelques questions sur sa vie comme maman et ses objectifs en tant que tireuse parmi les meilleures du monde : Comment avez-vous découvert l'escrime ? Mes parents adorent le sport et jouaient au basketball et au volleyball. Nos parents nous ont transmis leur amour du sport. Grigory, le plus âgé de mes frères, faisait de la plongée, et lui et Trofim, le plus jeune, faisaient également de la gymnastique pendant que j'ai commencé la danse de salon et à jouer du piano. Mon frère Grigory m'a fait découvrir l'escrime en 1998. À cette époque, nous vivions à Almaty, mais Grigory avait déjà déménagé à Moscou et pratiquait l'escrime. Un jour, il est venu à la maison et il nous a parlé d'une nouvelle discipline, le sabre féminin, et il m'a dit que je pourrais essayer. Une nouvelle discipline signifie toujours davantage de chances d'exploiter pleinement votre potentiel, et offre de nombreuses opportunités. J'ai donc arrêté d'étudier à l'école de musique au cours de ma dernière année pour me consacrer à l'escrime, et je me suis complètement immergée dans ce sport.  1 2 3 4 5 6 7",
    "mobileHtml": "\n      \n      <p>La Russe Sofya Velikaya, actuellement N\xB02 mondiale au sabre, est l'une des tireuses les plus accomplies de l'histoire : septuple championne du monde, deux fois en individuel et cinq fois par \xE9quipes, elle a \xE9galement remport\xE9 sept titres en Grand Prix. \xC0 34 ans, cette maman de deux enfants a remport\xE9 de nombreuses comp\xE9titions majeures d'escrime depuis le d\xE9but des ann\xE9es 2000, avec une premi\xE8re victoire en individuel aux Championnats du monde de Catane (Italie) en 2011. Nous lui avons pos\xE9 quelques questions sur sa vie et ses objectifs en tant que tireuse parmi les meilleures du monde:</p>\n\n      <p><strong>1) Comment avez-vous d\xE9couvert l'escrime ? Quel \xE2ge aviez-vous ?</strong></p>\n      <p>Mes parents adorent le sport et ont toujours \xE9t\xE9 tr\xE8s actifs et jouaient au basketball et au volleyball. Nos parents nous ont transmis leur amour du sport. J'ai deux fr\xE8res, Grigory, le plus \xE2g\xE9 de mes fr\xE8res, et Trofim, le plus jeune, et nous faisions sans cesse du sport. Grigory faisait de la plong\xE9e, et lui et Trofim faisaient \xE9galement de la gymnastique pendant que j'ai commenc\xE9 \xE0 apprendre la danse de salon et \xE0 jouer du piano. Grigory m'a fait d\xE9couvrir l'escrime en 1998. \xC0 cette \xE9poque, nous vivions \xE0 Almaty, mais Grigory avait d\xE9j\xE0 d\xE9m\xE9nag\xE9 \xE0 Moscou et pratiquait l'escrime. Un jour, il est venu \xE0 la maison et il nous a parl\xE9 d'une nouvelle discipline, le sabre f\xE9minin, et il m'a dit que je pourrais essayer. Une nouvelle discipline signifie toujours davantage de chances d'exploiter pleinement votre potentiel, et offre de nombreuses opportunit\xE9s. J'ai donc arr\xEAt\xE9 d'\xE9tudier \xE0 l'\xE9cole de musique au cours de ma derni\xE8re ann\xE9e pour me consacrer \xE0 l'escrime, et je me suis compl\xE8tement immerg\xE9e dans ce sport.</p>\n\n      <p><strong>2) Comment se sont pass\xE9es les premi\xE8res ann\xE9es d'escrime?</strong></p>\n      <p>Les deux premi\xE8res ann\xE9es, je ne r\xE9alisais pas tout ce que je voulais, mais j'obtenais de bons r\xE9sultats pour le Kazakhstan. En 2001, j'ai d\xE9m\xE9nag\xE9 en Russie et j'ai int\xE9gr\xE9 l'\xE9cole de la R\xE9serve olympique. Les conditions \xE9taient g\xE9niales, mais c'\xE9tait tr\xE8s exigeant : pour rester \xE0 l'\xE9cole, vos r\xE9sultats devaient \xEAtre homog\xE8nes et vous deviez \xEAtre un \xE9tudiant consciencieux. Le sport m'a donc rendu ind\xE9pendante d\xE8s l'\xE2ge de 15 ans.</p>\n\n      <p><strong>3) Par qui avez-vous \xE9t\xE9 le plus influenc\xE9e dans votre vie de tireuse ?</strong></p>\n      <p>Nos parents choisissaient nos sports pour nous de mani\xE8re \xE0 ce que nous puissions r\xE9aliser quelque chose par nous-m\xEAmes, J'ai une famille ordinaire, mon p\xE8re \xE9tait ing\xE9nieur et ma m\xE8re travaillait dans la vente. Mon fr\xE8re Grigory m'a beaucoup influenc\xE9e lorsque je faisais mes \xE9tudes \xE0 l'\xE9cole du sport.  Il m'a dit : \xAB L'\xE9cole t'apporte tout ce dont tu as besoin, elle te nourrit et met un toit au-dessus de ta t\xEAte. Tu peux accomplir quelque chose dans ce sport \xBB. J'ai parcouru un long chemin. J'ai eu des hauts et des bas. J'ai rencontr\xE9 de nombreuses personnes qui m'ont guid\xE9e et qui ont \xE9t\xE9 (et sont toujours) tr\xE8s importantes pour moi. L'une d'entre elles est mon entra\xEEneur, Dmitry Glotov, avec lequel j'ai partag\xE9 tant de choses, et bien s\xFBr Christian Bauer, qui est associ\xE9 \xE0 tous mes meilleurs r\xE9sultats.</p>\n\n      <p><strong>4) Comment parvenez-vous \xE0 combiner votre r\xF4le de maman de deux enfants et votre carri\xE8re de tireuse de haut niveau ? Comment faites-vous pour que cela fonctionne ?</strong></p>\n      <p>Mes enfants sont tout pour moi. Je suis parvenue \xE0 revenir deux fois dans le sport professionnel mais bien s\xFBr, ce n'est pas facile. Mes parents m'aident beaucoup, ainsi que la f\xE9d\xE9ration et les entra\xEEneurs qui font preuve de beaucoup de patience et de compr\xE9hension. Je suis tr\xE8s reconnaissante \xE0 ma famille, \xE0 mes parents et \xE0 mes fr\xE8res qui prennent soin de mes enfants lorsque je suis loin. Je passe tout mon temps libre avec mes enfants. Les entra\xEEneurs m'aident \xE0 adapter ma pr\xE9paration pour prendre en compte mes deux enfants. Bien s\xFBr, je suis souvent fatigu\xE9e, mais mes victoires me donnent la force de continuer.</p>\n\n      <p><strong>5) Parlez-nous de votre derni\xE8re saison - 2018-2019. Comment s'est-elle pass\xE9e ?</strong></p>\n      <p>\xC9tant donn\xE9 que j'ai repris le sport apr\xE8s avoir donn\xE9 naissance \xE0 Zoya \xE0 la fin de la saison 2017 et que j'ai obtenu de bons r\xE9sultats aux Championnats d'Europe et du monde, j'ai commenc\xE9 cette saison avec des entra\xEEnements \xE0 plein temps. Mon entra\xEEneur m'a pr\xE9par\xE9 un calendrier et un programme d'entra\xEEnement tenant compte de tous les d\xE9tails relatifs \xE0 ma sant\xE9 et \xE0 mon \xE2ge. J'\xE9tais de plus en plus en forme \xE0 chaque comp\xE9tition individuelle et par \xE9quipes. Je suis tr\xE8s heureuse que le processus de qualification olympique ait d\xE9j\xE0 commenc\xE9, et mes bons r\xE9sultats m'ont permis de faire davantage attention \xE0 la performance par \xE9quipes. Les r\xE9sultats par \xE9quipes sont extr\xEAmement importants pour moi et j'aimerais que notre \xE9quipe obtienne des r\xE9sultats plus homog\xE8nes. Je me sens responsable de tous les membres de notre \xE9quipe, surtout en \xE9tant celle qui termine les rencontres. Cette saison est tr\xE8s importante pour nous et notre \xE9quipe car nous devons r\xE9ussir le processus de s\xE9lection pour les Jeux Olympiques. Actuellement, c'est la chose la plus importante \xE0 mes yeux, beaucoup plus que mes r\xE9sultats individuels. Nous avons beaucoup de travail \xE0 abattre, mais d'un point de vue g\xE9n\xE9ral nous n'avons pas fait une mauvaise saison.</p>\n\n      <p><strong>6) Comment comparez-vous l'escrime individuelle et l'escrime par \xE9quipes ?</strong></p>\n      <p>En escrime individuelle, vous \xEAtes responsable de vous-m\xEAme uniquement. Lorsque vous tirez par \xE9quipes, vous \xEAtes responsable de tous les membres de cette \xE9quipe, y compris de toutes les personnes qui travaillent avec vous. Nos victoires par \xE9quipes sont tr\xE8s importantes et pr\xE9cieuses pour moi. C'est un sentiment incroyable que de ressentir toutes les \xE9motions de vos co\xE9quipi\xE8res et de toutes les personnes autour de vous apr\xE8s une victoire. au d\xE9but de ma carri\xE8re c'\xE9tait dificile, mais des personnes ont cru en moi et m'ont fait terminer les rencontres. Vous ne pouvez pas vous d\xE9tendre avant que la 45e touche ne soit marqu\xE9e. Lorsqu'on tire par \xE9quipes, chaque erreur co\xFBte cher et il est parfois tr\xE8s difficile de g\xE9rer cette pression.\n      </p>\n\n      <p><strong>7) Quel effet cela fait-il d'\xEAtre double championne du monde ?</strong></p>\n      <p>Si vous parlez de mes r\xE9sultats individuels, ces victoires sont mes plus brillantes. Les matches les plus difficiles et les adversaires les plus coriaces. Ces succ\xE8s sont tr\xE8s pr\xE9cieux pour moi, en particulier la victoire aux Championnats du monde de Moscou. Remporter ce type de comp\xE9tition dans votre ville et faire plaisir \xE0 toutes les personnes qui sont venues vous soutenir, cela cr\xE9e des moments inoubliables qui me donnent \xE9norm\xE9ment d'\xE9motions.</p>\n      \n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n          <a href=\"http://www.fencingsets.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:864px;left:283px;width:228px; height:30px;\"></div>\n          </a>\n\n          <a href=\"mailto:755037302@qq.com\">\n            <div class=\"contentLinkNone\" style=\"top:894px;left:283px;width:215px; height:30px;\"></div>\n          </a>\n\n          <a href=\"mailto:1135864400@qq.com\">\n            <div class=\"contentLinkNone\" style=\"top:894px;left:500px;width:173px; height:30px;\"></div>\n          </a>\n\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.fencingsets.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg18.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 19-title\" style=\"top:119px;left:86px\" src=\"/112/fr/static/_content/19-title.png\">\n\n      <img class=\"halfScale 19-line\" style=\"top:304px;left:87px\" src=\"/112/fr/static/_content/19-line.png\">\n\n      <img class=\"halfScale 19-sub\" style=\"top:303px;left:123px\" src=\"/112/fr/static/_content/19-sub.png\">\n\n      <img class=\"halfScale pointer 19-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/19-arrow.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax()\n          pg19Anim.fromTo(cOf(\"19-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"19-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"19-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"19-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop()\n        }\n      ",
    "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  LA JOURNÉE MONDIALE DE L'ESCRIME AIDE LA PLANÈTE ! LAUSANNE, SUISSE 7 SEPTEMBRE 2019",
    "mobileHtml": "\n      <h2>La Journ\xE9e mondiale de l'escrime aide la plan\xE8te !</h2>\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg19.jpg\">\n      <p><strong>LAUSANNE, Suisse, </strong></p>\n      <p><strong>7 septembre 2019</strong></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 20-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/19-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-green.png\">\n      </a>\n      <a href=\"https://www.youtube.com/watch?v=V6axJUC1Pzs\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:609px;left:49px\" src=\"/112/fr/static/_content/yt-green.png\">\n      </a>\n      <a href=\"https://www.instagram.com/explore/tags/fencingday/\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:848px;left:57px\" src=\"/112/fr/static/_content/ig-green.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax()\n          pg20Anim\n            .fromTo(cOf(\"20-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop()\n        }\n      ",
    "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/3  CLIQUEZ ICI pour consulter le page Youtube de la Journée mondiale de l'escrime  Des escrimeurs du monde entier se sont mobilisés lors de la troisième Journée mondiale de l'escrime, qui a eu lieu cette année le samedi 7 septembre, pour mettre leur détermination au service de leur communauté, avec notamment des actions humanitaires et de protection de l'environnement.  CLIQUEZ ICI pour voir la Journée mondiale de l'escrime sur Instagram  La Journée mondiale de l'escrime a été l'occasion pour les tireurs de se rassembler pour mener des actions en lien avec le thème de cette année, « L'escrime pour notre planète ». Aux quatre coins du monde, que ce soit par des projets pour aider l'environnement, de bonnes œuvres pour les personnes en difficulté dans la communauté,  ou par la mise en place de politiques de durabilité dans des clubs ou lors de tournois, la Journée mondiale de l'escrime et des tireurs des cinq continents se sont efforcés de rendre ce monde meilleur.",
    "mobileHtml": "\n      \n\n      \n      \n    \n      <p>Des escrimeurs du monde entier se sont mobilis\xE9s lors de la troisi\xE8me Journ\xE9e mondiale de l'escrime, qui a eu lieu cette ann\xE9e le samedi 7 septembre, pour mettre leur d\xE9termination au service de leur communaut\xE9, avec notamment des actions humanitaires et de protection de l'environnement.</p>\n\n      <p>La Journ\xE9e mondiale de l'escrime a \xE9t\xE9 l'occasion pour les tireurs de se rassembler pour mener des actions en lien avec le th\xE8me de cette ann\xE9e, \xAB L'escrime pour notre plan\xE8te \xBB. Aux quatre coins du monde, que ce soit par des projets pour aider l'environnement, de bonnes \u0153uvres pour les personnes en difficult\xE9 dans la communaut\xE9, ou par la mise en place de politiques de durabilit\xE9 dans des clubs ou lors de tournois, la Journ\xE9e mondiale de l'escrime et des tireurs des cinq continents se sont efforc\xE9s de rendre ce monde meilleur.</p>\n      \n      <p>Avez-vous particip\xE9 \xE0 la Journ\xE9e mondiale de l'escrime ? Si oui, il n'est pas trop tard pour nous envoyer vos r\xE9cits et vos photos ! Publiez des stories de vos bonnes actions (avec des photos s'il vous pa\xEEt !) sur les r\xE9seaux sociaux de la FIE (Facebook, Twitter ou Instagram), utilisez le hashtag #FencingforourPlanet, et vous serez automatiquement inscrit pour le tirage au sort qui vous permettra peut-\xEAtre de remporter une m\xE9daille comm\xE9morative du 105e anniversaire de la FIE. Plusieurs m\xE9dailles sont en jeu et la date limite approche, alors publiez votre story d\xE8s maintenant !</p>\n\n      \n      \n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 21-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/21-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax()\n          pg21Anim\n            .fromTo(cOf(\"21-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop()\n        }\n      ",
    "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 3/3  Avez-vous participé à la Journée mondiale de l'escrime ? Si oui, il n'est pas trop tard pour nous envoyer vos récits et vos photos ! Publiez des stories de vos bonnes actions (avec des photos s'il vous plaît !) sur les réseaux sociaux de la FIE (Facebook, Twitter ou Instagram), utilisez le hashtag #FencingforourPlanet, et vous serez automatiquement inscrit pour le tirage au sort qui vous permettra peut-être de remporter une médaille commémorative du 105e anniversaire de la FIE. Plusieurs médailles sont en jeu et la date limite approche, alors publiez votre story dès maintenant !  locaux, des fédérations nationales d'escrime et des entraîneurs d'escrime s'unissent pour faire découvrir l'escrime dans leurs régions. Les 153 fédérations membres de la FIE, réparties aux quatre coins du monde, organisent une multitude d'activités, et des fédérations, des clubs, des athlètes, des individus, des fabricants et des fans qui aiment l'escrime se joignent tous aux festivités. ■  À propos de la Journée mondiale de l'escrime Lors de la Journée mondiale de l'escrime, organisée chaque année le samedi du deuxième week-end de septembre, des athlètes ayant participé aux Olympiades et aux Championnats du monde, des clubs d'escrime  W W W.FIE .ORG",
    "mobileHtml": "\n      \n      \n\n      \n      <p><strong>\xC0 propos de la Journ\xE9e mondiale de l'escrime</strong></p>\n      <p>Lors de la Journ\xE9e mondiale de l'escrime, organis\xE9e chaque ann\xE9e le samedi du deuxi\xE8me week-end de septembre, des athl\xE8tes ayant particip\xE9 aux Olympiades et aux Championnats du monde, des clubs d'escrime locaux, des f\xE9d\xE9rations nationales d'escrime et des entra\xEEneurs d'escrime s'unissent pour faire d\xE9couvrir l'escrime dans leurs r\xE9gions. Les 153 f\xE9d\xE9rations membres de la FIE, r\xE9parties aux quatre coins du monde, organisent une multitude d'activit\xE9s, et des f\xE9d\xE9rations, des clubs, des athl\xE8tes, des individus, des fabricants et des fans qui aiment l'escrime se joignent tous aux festivit\xE9s. </p>\n\n      <p>Cliquez sur <a href=\"https://www.instagram.com/explore/tags/fencingforourplanet/\" target=\"_blank\">#FencingForOurPlanet</a> pour lire d'autres stories sur Instagram</p>\n\n      <p>D\xE9couvrez le <a href=\"https://twitter.com/hashtag/FencingDay?src=hashtag_click\" target=\"_blank\">#FencingDay</a> sur Twitter </p>\n      \n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n          <a href=\"http://www.blue-gauntlet.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:939px;left:250px;width:1080px; height:75px;\"></div>\n          </a>\n          \n          <a href=\"mailto:service@blue-gauntletservice.com\">\n            <div class=\"contentLinkNone\" style=\"top:1028px;left:384px;width:823px; height:49px;\"></div>\n          </a>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.blue-gauntlet.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg22.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 23-title\" style=\"top:148px;left:83px\" src=\"/112/fr/static/_content/23-title.png\">\n\n      <img class=\"halfScale 23-line\" style=\"top:506px;left:92px\" src=\"/112/fr/static/_content/23-line.png\">\n\n      <img class=\"halfScale 23-sub\" style=\"top:505px;left:127px\" src=\"/112/fr/static/_content/23-sub.png\">\n\n      <img class=\"halfScale pointer 23-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/19-arrow.png\">\n\n      <a href=\"https://twitter.com/hashtag/FencingDay?src=hashtag_click\" target=\"_blank\">\n        <div class=\"contentLinkNone\" style=\"top:915px;left:502px;width:223px; height:43px;\"></div>\n      </a>\n      ",
    "script": "\n        \n      function onPageEnter() {\n        pg23Anim = new TimelineMax()\n        pg23Anim.fromTo(cOf(\"23-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"23-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"23-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"23-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onClick: addContentLinks}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg23Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  JOURNÉE MONDIALE DE L'ESCRIME SIÈGE SOCIAL DE LA FIE LAUSANNE, SUISSE 7 SEPTEMBRE 2019",
    "mobileHtml": "\n      \n      <h2>Journ\xE9e mondiale de l'escrime - Si\xE8ge social de la FIE</h2> \n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg23.jpg\">\n      <p><strong>\n        LAUSANNE, Suisse</strong></p>\n      <p><strong>7 septembre 2019</strong></p>\n      \n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 24-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/21-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n\n\n      <a href=\"https://www.instagram.com/explore/tags/fencingforourplanet/\" target=\"_blank\">\n        <div class=\"contentLinkNone\" style=\"top:1036px;left:840px;width:257px; height:41px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax()\n          pg24Anim\n            .fromTo(cOf(\"24-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onClick: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  La troisième Journée mondiale de l'escrime, organisée chaque année, a eu lieu le samedi 7 septembre sur le thème « L'escrime pour notre planète ». Comme annoncé à l'avance, « la FIE espère ainsi que les tireurs peuvent montrer au monde que l'escrime n'est pas juste un sport, mais un état d'esprit positif qui peut proﬁter aussi bien aux individus qu'aux communautés dans lesquelles ils vivent. Le thème « L'escrime pour notre planète » de la Journée mondiale de l'escrime est un appel à l'action lancé à la famille mondiale de l'escrime pour montrer que l'escrime et les escrimeurs se soucient des personnes et de la planète ».  Le Siège social de la FIE a organisé l'initiative avec beaucoup d'enthousiasme, en coopération avec deux partenaires :  Dans l'esprit de ce message, et en phase avec un siège et une organisation qui accordent une attention toujours plus importante à la durabilité, le personnel du Siège social de la FIE à Lausanne a décidé collectivement d'organiser un nettoyage de la plage située à proximité de ses locaux et le long des rives du Lac de Genève, sur une section allant de la plage de Vidy à Saint-Sulpice. S'attaquer au problème des déchets jetés dans la nature est une mesure profitant à la fois à la santé humaine et à l'environnement.  Les types de déchets collectés sont saisis dans la base de données de l'ASL et analysés ensuite dans le cadre d'une enquête statistique visant à en apprendre davantage et à mieux comprendre comment protéger le lac Léman. L'impact de la contribution au ramassage des déchets du personnel de la FIE sera ainsi amplifié et accru, ce qui permettra d'aider encore davantage les personnes et l'environnement.  Cheval et Environnement, qui fournit un moyende transport écologique pour l'évacuation desordures l'ASL (Association for the Conservation of theLeman Lake), qui fournit les outils permettant de ramasser les déchets abandonnés dans les rues ou sur les plages  #FencingForOurPlanet. ■ W W W.FIE .ORG",

    "mobileHtml": "\n    \n      <p>La troisi\xE8me Journ\xE9e mondiale de l'escrime, organis\xE9e chaque ann\xE9e, a eu lieu le samedi 7 septembre sur le th\xE8me \xAB L'escrime pour notre plan\xE8te \xBB. Comme annonc\xE9 \xE0 l'avance, \xAB la FIE esp\xE8re ainsi que les tireurs peuvent montrer au monde que l'escrime n'est pas juste un sport, mais un \xE9tat d'esprit positif qui peut profiter aussi bien aux individus qu'aux communaut\xE9s dans lesquelles ils vivent. Le th\xE8me \xAB L'escrime pour notre plan\xE8te \xBB de la Journ\xE9e mondiale de l'escrime est un appel \xE0 l'action lanc\xE9 \xE0 la famille mondiale de l'escrime pour montrer que l'escrime et les escrimeurs se soucient des personnes et de la plan\xE8te \xBB.</p>\n      \n      <p>Dans l'esprit de ce message, et en phase avec un si\xE8ge et une organisation qui accordent une attention toujours plus importante \xE0 la durabilit\xE9, le personnel du Si\xE8ge social de la FIE \xE0 Lausanne a d\xE9cid\xE9 collectivement d'organiser un nettoyage de la plage situ\xE9e \xE0 proximit\xE9 de ses locaux et le long des rives du Lac de Gen\xE8ve, sur une section allant de la plage de Vidy \xE0 Saint-Sulpice. S'attaquer au probl\xE8me des d\xE9chets jet\xE9s dans la nature est une mesure profitant \xE0 la fois \xE0 la sant\xE9 humaine et \xE0 l'environnement.</p>\n      <p>Le Si\xE8ge social de la FIE a organis\xE9 l'initiative avec beaucoup d'enthousiasme, en coop\xE9ration avec deux partenaires :</p>\n\n      <p>- Cheval et Environnement, qui fournit un moyen de transport \xE9cologique pour l'\xE9vacuation des ordures</p>\n      <p>- l'ASL (Association for the Conservation of the Leman Lake), qui fournit les outils permettant de ramasser les d\xE9chets abandonn\xE9s dans les rues ou sur les plages</p>\n\n      <p>Les types de d\xE9chets collect\xE9s sont saisis dans la base de donn\xE9es de l'ASL et analys\xE9s ensuite dans le cadre d'une enqu\xEAte statistique visant \xE0 en apprendre davantage et \xE0 mieux comprendre comment prot\xE9ger le lac L\xE9man. L'impact de la contribution au ramassage des d\xE9chets du personnel de la FIE sera ainsi amplifi\xE9 et accru, ce qui permettra d'aider encore davantage les personnes et l'environnement.</p>\n\n      <p><a href=\"https://twitter.com/hashtag/FencingForOurPlanet?src=hashtag_click\" target=\"_blank\">#FencingForOurPlanet</a></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n          <a href=\"http://favero.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:769px;left:1000px;width:165px; height:55px;\"></div>\n          </a>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://favero.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg25.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n          <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:1000px;left:816px;width:223px; height:25px;\"></div>\n          </a>\n\n          <a href=\"mailto:jason@jiangfencing.com\">\n            <div class=\"contentLinkNone\" style=\"top:1025px;left:828px;width:239px; height:25px;\"></div>\n          </a>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.jiangfencing.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg26.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 27-title\" style=\"top:88px;left:694px\" src=\"/112/fr/static/_content/27-title.png\">\n\n      <img class=\"halfScale 27-line\" style=\"top:254px;left:702px\" src=\"/112/fr/static/_content/27-line.png\">\n\n      <img class=\"halfScale 27-sub\" style=\"top:248px;left:739px\" src=\"/112/fr/static/_content/27-sub.png\">\n\n      <img class=\"halfScale pointer 27-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/19-arrow.png\">\n      ",
    "script": "\n        \n      function onPageEnter() {\n        pg27Anim = new TimelineMax()\n        pg27Anim.fromTo(cOf(\"27-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"27-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"27-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"27-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg27Anim.stop()\n      }\n      ",
    "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES © Jose Sotomayor / Lima 2019  JEUX PANAMÉRICAINS LIMA, PÉROU 5 AU 10 AOÛT 2019",
    "mobileHtml": "\n      \n      <h2>Jeux Panam\xE9ricains</h2>\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg27.jpg\">\n      <p><strong>LIMA, P\xE9rou</strong></p>\n      <p><strong>5 au 10 ao\xFBt 2019</strong></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 28-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/21-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-green.png\">\n      </a>\n      <a href=\"https://static.fie.org/uploads/22/114371-Newsletter%20CPE%20Vol-3Num-1%20Aug%202019%20Eng.pdf\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:771px;left:36px\" src=\"/112/fr/static/_content/paper-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax()\n          pg28Anim\n            .fromTo(cOf(\"28-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop()\n        }\n      ",
    "searchText": "© Claudio Cruz/Lima 2019  ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  © Lima 2019  © Rojas Lima 2019  © Fidel Carrillo/Lima 2019  © César Fajardo/ Lima 2019  CLIQUEZ ICI pour consulter le bulletin d'information de la CPE.  La compétition d'escrime des dix-septième Jeux Panaméricains à Lima, Pérou, a été disputée par 156 athlètes de 16 fédérations nationales, avec au programme des épreuves hommes et dames en individuel et par équipes à l'épée, au fleuret et au sabre. La compétition s'est déroulée du 5 au 10 août au Centre de convention de la ville de Lima. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      \n      \n      \n\n      <p>La comp\xE9tition d'escrime des dix-septi\xE8me Jeux Panam\xE9ricains \xE0 Lima, P\xE9rou, a \xE9t\xE9 disput\xE9e par 156 athl\xE8tes de 16 f\xE9d\xE9rations nationales, avec au programme des \xE9preuves hommes et dames en individuel et par \xE9quipes \xE0 l'\xE9p\xE9e, au fleuret et au sabre. La comp\xE9tition s'est d\xE9roul\xE9e du 5 au 10 ao\xFBt au Centre de convention de la ville de Lima.</p>\n\n      <p>Pour consulter le bulletin d'information de la CPE, cliquez <a href=\"https://static.fie.org/uploads/22/114371-Newsletter%20CPE%20Vol-3Num-1%20Aug%202019%20Eng.pdf\" target=\"_blank\">ici.</a></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      <div class=\"contentLink\" style=\"bottom:193px;right:633px;width:180px; height:30px;\">\n      <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"bottom:198px;right:844px;width:30px; height:30px;\">\n        <a href=\"https://www.facebook.com/uhlmann.fencing/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"contentLink\" style=\"bottom:198px;right:813px;width:30px; height:30px;\">\n        <a href=\"http://www.instagram.com/Uhlmann.Fencing\" target=\"_blank\"></a>\n    </div>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.uhlmann-fencing.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg29.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 30-title\" style=\"top:221px;left:83px\" src=\"/112/fr/static/_content/30-title.png\">\n\n      <img class=\"halfScale 30-line\" style=\"top:572px;left:89px\" src=\"/112/fr/static/_content/30-line.png\">\n\n      <img class=\"halfScale 30-sub\" style=\"top:572px;left:125px\" src=\"/112/fr/static/_content/30-sub.png\">\n\n      <img class=\"halfScale pointer 30-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/19-arrow.png\">\n      ",
    "script": "\n        \n      function onPageEnter() {\n        pg30Anim = new TimelineMax()\n        pg30Anim.fromTo(cOf(\"30-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"30-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"30-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"30-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg30Anim.stop()\n      }\n      ",
    "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  LA VILLE DE GUATEMALA CÉLÈBRE LA JOURNÉE MONDIALE DE L'ESCRIME GUATEMALA, GUATEMALA 7 SEPTEMBRE 2019",
    "mobileHtml": "\n      \n      <h2>La ville de Guatemala c\xE9l\xE8bre la Journ\xE9e mondiale de l'escrime</h2>\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg30.jpg\">\n      <p><strong>GUATEMALA, GUATEMLA</strong></p>\n      <p><strong>7 septembre 2019</strong></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 31-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/21-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-green.png\">\n      </a>\n      <a href=\"https://www.youtube.com/watch?v=f0UbfMNTScE&feature=youtu.be\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:638px;left:49px\" src=\"/112/fr/static/_content/yt-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/pg/FederacionNacionalDeEsgrimaGuatemala/photos/?tab=album&album_id=2302027523229081&__xts__%5B0%5D=68.ARA7BG0xhcCICYBxCJEXu6hY87Df3urP17Apsz10GWy4neOzovRJpCGWYSrh6R-7Jf-NqL_4SdgIB1aNAMsHnxWUtAX9d9KDFX0mjCKWRNxbfDag6HYQSXNCSHjvgLKUQnTPQgnTD7ybrITtD2dMakiUfb9e7k5L8YhL8YQcnhfrCgtUfUtgbsHluwuNFHqe31DS86JB05Q2J2OQwjmYkSm83HaEeN4QiEUyglSKYtTzcg7RZEO4DW37TmFU8pV9cV1g5M8jbC4hMHv1NA2Pil9hrx3zYM9nLPJXzOBtM-2yObUC1IiU_y5Poa73jf3KvSbPV78BiQyuYD2sxex0biYmA2h0XiCj4VKMvTdq9gXrNuOcdTh7aMNbNy4ttrz6PpaclC82IJ9B9YIS4jmThhYg4_TJJxqTZy9Cq9y3RYHmFX98Y9qUbSOEiXyA4ZqRa5zUoPL_nUc0cywgo-MAqpdXhb9hrcGddotGh8981wB-zsW1EIraD_LW32w3bhQGx-3hvVlh3ZuQOHVZlf8gP4A4f9uyF3BTQZ7TlqSI__HAwj2Bb2shVwSB4XkKDBtcbk3q_SDvg9nSsGcZIZDOLjlkSyJyUEaUoT2TeMyilIUs8zzvc-ebVs3o2n_zzVaFKMQ1qfeJ7aR_58B0WkWrHE3zUIVntLfJPEjYoYkr52WE6IFxbSlZ8-JYDA3z73puH8JTdEWHQcnbC9mL5uvxLw&__tn__=-UC-R\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:857px;left:48px\" src=\"/112/fr/static/_content/pic-green.png\">\n      </a>\n\n      <a href=\"https://twitter.com/search?q=%23WorldFencingDay&src=typed_query\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:1012px;left:846px;width:206px; height:28px;\"></div>\n      </a>\n\n      <a href=\"https://twitter.com/hashtag/FencingDay?src=hashtag_click\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:1012px;left:1053px;width:146px; height:28px;\"></div>\n      </a>\n\n      <a href=\"https://twitter.com/hashtag/fencingforourplanet\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:1042px;left:845px;width:246px; height:28px;\"></div>\n      </a>\n\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax()\n          pg31Anim\n            .fromTo(cOf(\"31-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop()\n        }\n      ",
    "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  CLIQUEZ ICI pour regarder les videos de l'événement sur Youtube  CLIQUEZ ICI pour voir les images  Afin de célébrer la Journée mondiale de l'escrime, qui s’est déroulée le 7 septembre, la Fédération nationale d'escrime du Guatemala a organisé la plantation de 100 arbres en lien avec le thème « L'escrime pour notre planète » de l'événement annuel. Des bénévoles ont rejoint des membres de la Fédération pour aider à planter des pousses d'érythrine et de frêne à proximité de l’Asunción Ecological Park de la ville de Guatemala. L'effort a été mené dans le cadre d'une initiative plus vaste visant à encourager les pratiques de durabilité dans le pays, et a été illustré par des  photos et des vidéos avec le soutien de plusieurs organisations, notamment la Confédération des sports autonomes de Guatemala et la Municipalité de Guatemala.  #WorldFencingDay #FencingDay #FencingForOurPlanet. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      \n      \n\n\n\n      <p>Afin de c\xE9l\xE9brer la Journ\xE9e mondiale de l'escrime, qui s\u2019est d\xE9roul\xE9e le 7 septembre, la F\xE9d\xE9ration nationale d'escrime du Guatemala a organis\xE9 la plantation de 100 arbres en lien avec le th\xE8me \xAB L'escrime pour notre plan\xE8te \xBB de l'\xE9v\xE9nement annuel. Des b\xE9n\xE9voles ont rejoint des membres de la F\xE9d\xE9ration pour aider \xE0 planter des pousses d'\xE9rythrine et de fr\xEAne \xE0 proximit\xE9 de l\u2019Asunci\xF3n Ecological Park de la ville de Guatemala. L'effort a \xE9t\xE9 men\xE9 dans le cadre d'une initiative plus vaste visant \xE0 encourager les pratiques de durabilit\xE9 dans le pays, et a \xE9t\xE9 illustr\xE9 par des photos et des vid\xE9os avec le soutien de plusieurs organisations, notamment la Conf\xE9d\xE9ration des sports autonomes de Guatemala et la Municipalit\xE9 de Guatemala.</p>\n\n      <p><a href=\"https://twitter.com/search?q=%23WorldFencingDay&src=typed_query\" target=\"_blank\">#WorldFencingDay</a> <a href=\"https://twitter.com/hashtag/FencingDay?src=hashtag_click\" target=\"_blank\">#FencingDay</a> <a href=\"https://twitter.com/hashtag/fencingforourplanet\" target=\"_blank\">#FencingForOurPlanet</a></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n          <a href=\"mailto:sales@pbtfencing.com\">\n            <div class=\"contentLinkNone\" style=\"top:1057px;left:66px;width:263px; height:28px;\"></div>\n          </a>\n\n          <a href=\"http://www.pbtfencing.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:1057px;left:643px;width:249px; height:28px;\"></div>\n          </a>\n\n          <a href=\"https://www.instagram.com/pbt_fencing/\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:1057px;left:1129px;width:343px; height:28px;\"></div>\n          </a>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"http://www.pbtfencing.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg32.jpg\">\n      </a>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 33-title\" style=\"top:793px;left:70px\" src=\"/112/fr/static/_content/33-title.png\">\n\n      <img class=\"halfScale 33-line\" style=\"top:1002px;left:341px\" src=\"/112/fr/static/_content/33-line.png\">\n\n      <img class=\"halfScale 33-sub\" style=\"top:1002px;left:377px\" src=\"/112/fr/static/_content/33-sub.png\">\n\n      <img class=\"halfScale pointer 33-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/19-arrow.png\">\n      ",
    "script": "\n        \n      function onPageEnter() {\n        pg33Anim = new TimelineMax()\n        pg33Anim.fromTo(cOf(\"33-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"33-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"33-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"33-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg33Anim.stop()\n      }\n      ",
    "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  CAMP D’ENTRAÎNEMENT DE LA FIE À BUDAPEST BUDAPEST, HONGRIE 8 AU 12 JUILLET 2019",
    "mobileHtml": "\n      \n      <h2>CAMP D\u2019ENTRAINEMENT DE LA FIE A BUDAPEST</h2>\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg33.jpg\">\n      <p><strong>Budapest, Hongrie</strong></p>\n      <p><strong>8 au 12 juillet 2019</strong></p>\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 34-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/21-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <img class=\"halfScaleC pointer halfpulse animatedpulse\" onclick=\"showOverlay('34-pop')\" style=\"top:634px;left:53px\" src=\"/112/fr/static/_content/notepad-gr.png\">\n      <a href=\"https://youtu.be/_RZ-Oi4qUuU\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:870px;left:50px\" src=\"/112/fr/static/_content/yt-green.png\">\n      </a>\n\n      <div id=\"34-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/34-pop.jpg\">\n        <div class=\"contentLink\" style=\"top: 82px; left: 81px; width: 181px; height: 49px;opacity:0\" onclick=\"hideOverlay('34-pop');\"></div>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax()\n          pg34Anim\n            .fromTo(cOf(\"34-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop()\n        }\n      ",
    "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  La FIE a organisé un camp d’entraînement la semaine avant les Championnats du monde Senior à Budapest, en Hongrie. Sélectionnés par les Confédérations, 20 athlètes de toutes les armes ont pris part à une semaine intensive d’entraînement. Il y avait 10 hommes et 10 femmes âgés de 18 à 35 ans, de la Dominique, du Nigeria, de Irlande, de la Malaisie, de la Nouvelle-Zélande, parmi d’autres pays. Deux sessions d’entraînement par jour étaient organisées pour que les athlètes soient prêts à participer à la compétition la plus importante de l’année, les Championnats du monde Senior (15-23 juillet 2019).  CLIQUEZ ICI pour consulter les faits et chiffres du camp de la FIE  CLIQUEZ ICI pour regarder les temps forts  Les entraînements ont eu lieu à la salle de sport nationale Aladar Gerevich où l’équipe nationale hongroise s’entraîne durant la saison, et où les délégations des championnats du monde se préparaient pour la compétition. Les trois entraîneurs désignés étaient Alina Zholudeva, Cyril Tahon et Petru Kuki. « L’atmosphère et la collaboration étaient très bonnes », a avancé ce dernier. D’après Cyril  Tahon, l’organisation du camp d’entraînement était optimale, les athlètes étaient motivés et avaient soif d’apprendre. Quant à Alina Zholudeva, elle a loué le travail ardu des tireurs et le déroulement du camp. En plus des entraînements, les athlètes ont pris part à l’atelier du CIO « 365 Career + » qui vise à préparer les athlètes pour leur carrière professionnelle après le sport. Des vidéos, jeux et échanges entre eux ont rendu l’atelier interactif et vivant. À la compétition, Teodora Kakhiani de Géorgie a terminé 30ème au sabre féminin. Le prochain camp d’entraînement de la FIE aura lieu à Salt Lake City (USA) avant les Championnats du monde Junior & Cadet, en mars 2020. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      \n      \n      \n      \n      \n      \n      \n      \n      \n\n      <p>La FIE a organis\xE9 un camp d\u2019entra\xEEnement la semaine avant les Championnats du monde Senior \xE0 Budapest, en Hongrie.</p>\n      <p>S\xE9lectionn\xE9s par les Conf\xE9d\xE9rations, 20 athl\xE8tes de toutes les armes ont pris part \xE0 une semaine intensive d\u2019entra\xEEnement. Il y avait 10 hommes et 10 femmes \xE2g\xE9s de 18 \xE0 35 ans, de la Dominique, Nigeria, Irlande, Malaisie, Nouvelle-Z\xE9lande, parmi d\u2019autres pays.</p>\n      <p>Deux sessions d\u2019entra\xEEnement par jour \xE9taient organis\xE9es pour que les athl\xE8tes soient pr\xEAts \xE0 participer \xE0 la comp\xE9tition la plus importante de l\u2019ann\xE9e, les Championnats du monde Senior (15-23 juillet 2019).</p>\n      <p>Les entra\xEEnements ont eu lieu \xE0 la salle de sport nationale Aladar Gerevich o\xF9 l\u2019\xE9quipe nationale hongroise s\u2019entra\xEEne durant la saison, et o\xF9 les d\xE9l\xE9gations des championnats du monde se pr\xE9paraient pour la comp\xE9tition..</p>\n      <p>Les trois entra\xEEneurs d\xE9sign\xE9s \xE9taient Alina Zholudeva, Cyril Tahon et Petru Kuki. \xAB L\u2019atmosph\xE8re et la collaboration \xE9taient tr\xE8s bonnes \xBB, a avanc\xE9 ce dernier. D\u2019apr\xE8s Cyril Tahon, l\u2019organisation du camp d\u2019entra\xEEnement \xE9tait optimale, les athl\xE8tes \xE9taient motiv\xE9s et avaient soif d\u2019apprendre. Quant \xE0 Alina Zholudeva, elle a lou\xE9 le travail ardu des tireurs et le d\xE9roulement du camp.</p>\n      <p>En plus des entra\xEEnements, les athl\xE8tes ont pris part \xE0 l\u2019atelier du CIO \xAB 365 Career + \xBB qui vise \xE0 pr\xE9parer les athl\xE8tes pour leur carri\xE8re professionnelle apr\xE8s le sport. Des vid\xE9os, jeux et \xE9changes entre eux ont rendu l\u2019atelier interactif et vivant.</p>\n      <p>A la comp\xE9tition, Teodora Kakhiani de G\xE9orgie a termin\xE9 30\xE8me au sabre f\xE9minin.</p>\n      <p>Le prochain camp d\u2019entra\xEEnement de la FIE aura lieu \xE0 Salt Lake City (USA) avant les Championnats du monde Junior & Cadet, en mars 2020.</p>\n\n      <p>Quelques chiffres :</p>\n      <p>\u2022\t10 hommes et 10 femmes</p>\n      <p>\u2022\t9 \xE9p\xE9istes</p>\n      <p>\u2022\t5 fleurettistes</p>\n      <p>\u2022\t6 sabreurs</p>\n      <p>\u2022\t6 athl\xE8tes d\u2019Asie-Oc\xE9anie</p>\n      <p>\u2022\t8 athl\xE8tes d\u2019Europe</p>\n      <p>\u2022\t1 athl\xE8te d\u2019Afrique (un s\u2019est retir\xE9)</p>\n      <p>\u2022\t5 athl\xE8tes des Am\xE9riques</p>\n      \n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/112/fr/static/_mobile/pg35.jpg\">\n        "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 36-title\" style=\"top:764px;left:167px\" src=\"/112/fr/static/_content/36-title.png\">\n\n      <img class=\"halfScale 36-line\" style=\"top:1037px;left:344px\" src=\"/112/fr/static/_content/36-line.png\">\n\n      <img class=\"halfScale 36-sub\" style=\"top:1032px;left:379px\" src=\"/112/fr/static/_content/36-sub.png\">\n\n      <img class=\"halfScale pointer 36-arrow\" style=\"top:845px;left:1408px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/19-arrow.png\">\n      ",
    "script": "\n        \n      function onPageEnter() {\n        pg36Anim = new TimelineMax()\n        pg36Anim.fromTo(cOf(\"36-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n          .fromTo(cOf(\"36-line\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"36-sub\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n          .fromTo(cOf(\"36-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, \"-=0.2\")\n      }\n\n      function onPageLeave() {\n        pg36Anim.stop()\n      }\n      ",
    "searchText": "ACTUALITÉS DE L A FIE E T DES FÉDÉR ATIONS NATIONALES  COURS POUR ENTRAÎNEURS DE LA SOLIDARITÉ OLYMPIQUE AOÛT-SEPTEMBRE 2019",
    "mobileHtml": "\n      \n      <h2>Solidarit\xE9 Olympique - Cours pour entra\xEEneurs</h2>\n      <img id=\"fwdimg\" src=\"/112/fr/static/_mobile/pg36.jpg\">\n      <p><strong>ao\xFBt-septembre 2019</strong></p>\n      \n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 37-arrow\" style=\"top:845px;left:1388px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/21-arrow.png\">\n\n      <a href=\"https://twitter.com/FIE_fencing\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:54px\" src=\"/112/fr/static/_content/tw-green.png\">\n      </a>\n      <a href=\"https://www.facebook.com/fie.org\" target=\"_blank\">\n        <img class=\"halfScaleC pointer halfpulse animatedpulse\" style=\"top:422px;left:123px\" src=\"/112/fr/static/_content/fb-green.png\">\n      </a>\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg37Anim = new TimelineMax()\n          pg37Anim\n            .fromTo(cOf(\"37-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n        }\n\n        function onPageLeave() {\n          pg37Anim.stop()\n        }\n      ",
    "searchText": "ACTUALITÉS DE LA FIE ET DES FÉDÉRATIONS NATIONALES 2/2  L’enseignement de l’escrime a été mis en lumière en Asie, Afrique et Pan Amérique. En effet, cinq cours techniques pour entraîneurs de la Solidarité Olympique étaient organisés en Angola, Mongolie, Haïti, Colombie et à Bahreïn, entre août et septembre 2019. Affiliée à la FIE depuis le Congrès 2017, la fédération d’Angola a accueilli le premier cours pour entraîneurs de son histoire. Dirigé par Régis Trois de Avila, le cours a rassemblé près de 40 participants hommes et femmes sur une durée de 8 jours à Luanda. Depuis, les participants ont préparé leurs tireurs pour le championnat national de la fin de 2019. Ulaan Bator, en Mongolie, a rassemblé une vingtaine de participants, tous entraîneurs confirmés, durant une semaine de cours à l’épée. Aleksandr Rovniagin a encadré ce séminaire technique en mettant l’accent sur la pratique : jeu de jambes, attaques simples à complexes, actions pour choisir la distance exigée, entre autres. Matteo Scamarda s’est quant à lui rendu à Bahreïn pour un cours de 11 jours. Près de  30 participants hommes et femmes ont suivi la formation à l’épée et au fleuret. Ils ont été entraînés aux techniques de base, aspects psychologique et comportemental, stratégies de combat et à l’arbitrage. En septembre, la fédération haïtienne a reçu la visite de Mario Bourdageau pour un séminaire de 10 jours à Port-au-Prince, au fleuret. Le cours s’est déroulé durant 70 heures, comptant 25 participants, entraîneurs ou athlètes haïtiens. Mario Bourdageau a abordé les fondamentaux : travail de jambes, attaques et défenses simples, comment diriger un groupe en sécurité, et arbitrage, notamment. En Colombie, un cours au fleuret était organisé sur 13 jours à Bogotá. Une vingtaine de participants étaient formés par Luca Papale. Les leçons étaient basées sur les fondamentaux : attaques, ripostes, contre-attaques et jeu de jambes. ■ W W W.FIE .ORG",
    "mobileHtml": "\n      \n      <p>L\u2019enseignement de l\u2019escrime a \xE9t\xE9 mis en lumi\xE8re en Asie, Afrique et Pan Am\xE9rique. En effet, cinq cours techniques pour entra\xEEneurs de la Solidarit\xE9 Olympique \xE9taient organis\xE9s en Angola, Mongolie, Ha\xEFti, Colombie et \xE0 Bahre\xEFn, entre ao\xFBt et septembre 2019.</p>\n\n      <p>Affili\xE9e \xE0 la FIE depuis le Congr\xE8s 2017, la f\xE9d\xE9ration d\u2019Angola a accueilli le premier cours pour entra\xEEneurs de son histoire. Dirig\xE9 par R\xE9gis Trois de Avila, le cours a rassembl\xE9 pr\xE8s de 40 participants hommes et femmes sur une dur\xE9e de 8 jours \xE0 Luanda. Depuis, les participants ont pr\xE9par\xE9 leurs tireurs pour le championnat national de la fin de 2019.</p>\n\n      <p>Ulaan Bator, en Mongolie, a rassembl\xE9 une vingtaine de participants, tous entra\xEEneurs confirm\xE9s, durant une semaine de cours \xE0 l\u2019\xE9p\xE9e. Aleksandr Rovniagin a encadr\xE9 ce s\xE9minaire technique en mettant l\u2019accent sur la pratique : jeu de jambes, attaques simples \xE0 complexes, actions pour choisir la distance exig\xE9e, entre autres.</p>\n\n      <p>Matteo Scamarda s\u2019est quant \xE0 lui rendu \xE0 Bahre\xEFn pour un cours de 11 jours. Pr\xE8s de 30 participants hommes et femmes ont suivi la formation \xE0 l\u2019\xE9p\xE9e et au fleuret. Ils ont \xE9t\xE9 entra\xEEn\xE9s aux techniques de base, aspects psychologique et comportemental, strat\xE9gies de combat et \xE0 l\u2019arbitrage.</p>\n\n      <p>En septembre, la f\xE9d\xE9ration ha\xEFtienne a re\xE7u la visite de Mario Bourdageau pour un s\xE9minaire de 10 jours \xE0 Port-au-Prince, au fleuret. Le cours s\u2019est d\xE9roul\xE9 durant 70 heures, comptant 25 participants, entra\xEEneurs ou athl\xE8tes ha\xEFtiens. Mario Bourdageau a abord\xE9 les fondamentaux : travail de jambes, attaques et d\xE9fenses simples, comment diriger un groupe en s\xE9curit\xE9, et arbitrage, notamment.</p>\n\n      <p>En Colombie, un cours au fleuret \xE9tait organis\xE9 sur 13 jours \xE0 Bogot\xE1. Une vingtaine de participants \xE9taient form\xE9s par Luca Papale. Les le\xE7ons \xE9taient bas\xE9es sur les fondamentaux : attaques, ripostes, contre-attaques et jeu de jambes.</p>\n      \n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <img src=\"/112/fr/static/_mobile/pg38.jpg\">\n        "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n\n          <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:769px;left:18px;width:614px; height:43px;\"></div>\n          </a>\n\n          <a href=\"mailto:info@fencewithfun.com\">\n            <div class=\"contentLinkNone\" style=\"top:940px;left:75px;width:219px; height:28px;\"></div>\n          </a>\n\n          <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:942px;left:353px;width:214px; height:28px;\"></div>\n          </a>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n      \n      <a href=\"https://www.fencewithfun.com\" target=\"_blank\">\n        <img src=\"/112/fr/static/_mobile/pg39.jpg\">\n      </a>\n        "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale pointer 40-arrow\" style=\"top:938px;left:1174px\" onclick=\"Publish.goToNextPage()\" src=\"/112/fr/static/_content/40-arrow.png\">\n      <img class=\"halfScale 40-title\" style=\"top:126px;left:85px\" src=\"/112/fr/static/_content/40-title.png\">\n      <img class=\"halfScale 40-logo\" style=\"top:117px;left:1270px\" src=\"/112/fr/static/_content/40-logo.png\">\n      <a href=\"http://www.fie.org\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"bottom:5px;right:70px;width:130px; height:30px;\"></div>\n      </a>\n      <div class=\"addContentLink\" onclick=\"showOverlay('40-pop-1')\" style=\"top:397px;left:155px;width:399px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('40-pop-2')\" style=\"top:981px;left:129px;width:399px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('40-pop-3')\" style=\"top:435px;left:1067px;width:370px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('40-pop-4')\" style=\"top:644px;left:1067px;width:370px;height:36px\"></div>\n      <div class=\"addContentLink\" onclick=\"showOverlay('40-pop-5')\" style=\"top:819px;left:1067px;width:370px;height:36px\"></div>\n\n      <div id=\"40-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/40-pop-bg.jpg\">\n        <img id=\"\" class=\"halfScale\" style=\"top:300px;left:81px;\" src=\"/112/fr/static/_content/40-pop-1.png\">\n\n        <a href=\"https://youtu.be/UaKsXFM85hw\" target=\"_blank\">\n          <svg class=\"abs pointer\" style=\"bottom:195px;left:1012px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n          </svg>\n        </a>\n\n        <a href=\"https://tokyo2020.org/en/special/countdown/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:850px;left:1230px;width:51px; height:51px;\"></div>\n        </a>\n\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0\" onclick=\"hideOverlay('40-pop-1');\"></div>\n      </div>\n\n      <div id=\"40-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/40-pop-bg.jpg\">\n        <img id=\"\" class=\"halfScale\" style=\"top:150px;left:81px;\" src=\"/112/fr/static/_content/40-pop-2.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0\" onclick=\"hideOverlay('40-pop-2');\"></div>\n        \n        <a href=\"https://fie.org/competitions\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:466px;left:1097px;width:34px; height:28px;\"></div>\n        </a>\n        \n        <a href=\"https://www.instagram.com/fencing_fie/?hl=en\" target=\"_blank\">\n          <img class=\"halfScale\" style=\"top:887px;left:779px\" src=\"/112/fr/static/_content/ig-yel.png\">\n        </a>\n\n        <a href=\"https://youtu.be/6oicUedEcAc\" target=\"_blank\">\n          <svg class=\"abs pointer\" style=\"bottom:485px;left:992px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n            <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n          </svg>\n        </a>\n\n        <a href=\"https://youtu.be/yWxegnMT-_o\" target=\"_blank\">\n        <svg class=\"abs pointer\" style=\"bottom:485px;left:1262px;\" width=\"69.4px\" height=\"67.4px\" viewBox=\"0 0 69.4 67.4\">\n          <path fill=\"#ffffff\" d=\"M52,34.4L24,50.6V18.1L52,34.4z M67.4,33.7C67.4,15.1,52.3,0,33.7,0C15.1,0,0,15.1,0,33.7 c0,18.6,15.1,33.7,33.7,33.7C52.3,67.4,67.4,52.3,67.4,33.7\"/>\n        </svg>\n        </a>\n      </div>\n\n      <div id=\"40-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/40-pop-bg.jpg\">\n        <img id=\"\" class=\"halfScale\" style=\"top:199px;left:90px;\" src=\"/112/fr/static/_content/40-pop-3.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0\" onclick=\"hideOverlay('40-pop-3');\"></div>\n        <a href=\"http://www.vultureday.org/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:1057px;left:960px;width:216px; height:28px;\"></div>\n        </a>\n      </div>\n\n      <div id=\"40-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/40-pop-bg.jpg\">\n        <img id=\"\" class=\"halfScale\" style=\"top:149px;left:126px;\" src=\"/112/fr/static/_content/40-pop-4.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0\" onclick=\"hideOverlay('40-pop-4');\"></div>\n        <a href=\"https://www.cannescorporate.com/\" target=\"_blank\">\n          <div class=\"contentLinkNone\" style=\"top:858px;left:975px;width:39px; height:28px;\"></div>\n        </a>\n      </div>\n\n      <div id=\"40-pop-5\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"halfScale\" style=\"top:0px;left:0px\" src=\"/112/fr/static/_content/40-pop-bg.jpg\">\n        <img id=\"\" class=\"halfScale\" style=\"top:138px;left:81px;\" src=\"/112/fr/static/_content/40-pop-5.png\">\n        <div class=\"addContentLink\" style=\"top: 50px; left: 1328px; width: 168px; height: 49px;opacity:0\" onclick=\"hideOverlay('40-pop-5');\"></div>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax()\n          pg40Anim\n            .fromTo(cOf(\"40-title\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1}, 1)\n            .fromTo(cOf(\"40-logo\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1}, \"-=0.2\")\n            .fromTo(cOf(\"40-arrow\"), 0.6, {x:-60, opacity:0}, {x:0, opacity:1, onComplete: addContentLinks}, \"-=0.2\")\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          hideOverlay('40-pop-1');\n          hideOverlay('40-pop-2');\n          hideOverlay('40-pop-3');\n          hideOverlay('40-pop-4');\n          hideOverlay('40-pop-5');\n          removeContentLinks();\n        }\n      ",
    "searchText": "ACTUALITÉS  ACTUALITÉS DE LA FIE 1  Tokyo 2020 : plus qu'un an !  3  Cliquez ici pour en savoir plus  WWW.FIE.ORG  Le Botswana fête la Journée mondiale de l'escrime Cliquez ici pour en savoir plus  4  Une vidéo d'escrime de Budapest primée à Cannes Cliquez ici pour en savoir plus  5  Donate Your Fencing Gear! au Paraguay Cliquez ici pour en savoir plus  2  Le tournoi satellite d'escrime à Tachkent Cliquez ici pour en savoir plus  W W W.FIE .ORG",
    "mobileHtml": "\n      \n\n      <h2>Tokyo 2020 : plus qu'un an ! </h2>\n      <p>\xC0 tout juste un an du d\xE9but des Jeux Olympiques 2020 \xE0 Tokyo, les tireurs du monde entier attendent avec impatience de se plonger dans les activit\xE9s, les qualifications et l'esprit des Jeux au cours des mois \xE0 venir. Lors des Championnats du monde d'escrime 2019 \xE0 Budapest, qui se sont termin\xE9s le 23 juillet, des athl\xE8tes internationaux fougueux et enthousiastes ont donn\xE9 le coup d'envoi de l'ann\xE9e restante, ainsi qu'un aper\xE7u de leurs attentes pour eux-m\xEAmes, leurs \xE9quipes et le monde, \xE0 l'approche des Jeux Olympiques. </p>\n      <p>La FIE et ses 153 f\xE9d\xE9rations membres collaborent et m\xE8nent ensemble un grand nombre d'activit\xE9s pour soutenir les nombreuses initiatives du Comit\xE9 d'organisation de Tokyo 2020, en particulier des projets impliquant et promouvant la durabilit\xE9 environnementale dans le monde.</p>\n      <p>Davantage d'informations officielles concernant le compte \xE0 rebours pour Tokyo 2020 sont disponibles <a href=\"https://tokyo2020.org/en/special/countdown/\" target=\"_blank\">ici</a>.</p>\n      <p><a href=\"https://twitter.com/search?q=%231YearToGo&src=typed_query\" target=\"_blank\">#1YearToGo</a></p>\n\n      <h2>Le tournoi satellite d'escrime \xE0 Tachkent</h2>\n      <p>Des tireurs de 19 pays ont particip\xE9 aux \xE9preuves individuelles \xE0 l'\xE9p\xE9e et au fleuret du tournoi satellite de la FIE \xE0 Tachkent, \xE0 l'occasion duquel des r\xE9unions, des d\xE9monstrations d'escrime et des championnats r\xE9gionaux ont \xE9galement \xE9t\xE9 organis\xE9s. Le tournoi satellite FIE Fleuret et \xC9p\xE9e de Tachkent a attir\xE9 environ 120 tireurs et tireuses qui ont entam\xE9 avec enthousiasme leur saison de comp\xE9tition 2019-2020.</p>\n      <p>Le tournoi satellite, organis\xE9 du 5 au 8 septembre, a \xE9t\xE9 suivi par les Championnats d'Asie centrale, les 9 et 10 septembre, qui comprenaient des \xE9preuves aux trois armes. Des tireurs d'un grand nombre de pays d'Asie centrale et d'ailleurs \xE9taient en lice, notamment des athl\xE8tes d'Afghanistan, de Russie, d'Azerba\xEFdjan, de G\xE9orgie et de Malaisie. Parall\xE8lement \xE0 la comp\xE9tition, le Comit\xE9 ex\xE9cutif de la Conf\xE9d\xE9ration d'Asie centrale a organis\xE9 des r\xE9unions, ax\xE9es en particulier sur le th\xE8me \xAB En route vers Tokyo 2020 \xBB et sur l'implication de l'organisation dans les prochains Jeux Olympiques d'\xE9t\xE9.</p>\n      <p>Le Comit\xE9 ex\xE9cutif de la Conf\xE9d\xE9ration d'Asie centrale a indiqu\xE9 que, l'ann\xE9e 2020 \xE9tant une ann\xE9e olympique, les prochains Championnats d'Asie centrale seraient \xE9largis pour inclure les jeunes et les v\xE9t\xE9rans afin de promouvoir l'escrime au sein de groupes d'\xE2ges plus jeunes et plus \xE2g\xE9s et de les faire participer davantage \xE0 l'effervescence qui entoure l'escrime olympique. Des \xE9preuves de la semaine se sont d\xE9roul\xE9es le 7 septembre, Journ\xE9e mondiale de l'escrime. \xC0 cette occasion, la Conf\xE9d\xE9ration a organis\xE9 des d\xE9monstrations d'escrime pour plus de 250 enfants dans plusieurs \xE9coles de la r\xE9gion.</p>\n      <p>Les r\xE9sultats officiels du tournoi satellite FIE Fleuret et \xC9p\xE9e de Tachkent sont disponibles <a href=\"https://fie.org/competitions\" target=\"_blank\">ici</a>.</p>\n      <p> <a href=\"https://twitter.com/search?q=%231YearToGo&src=typed_query\" target=\"_blank\">#1YearToGo</a></p>\n\n      \n      \n      \n      <h2>Le Botswana f\xEAte la Journ\xE9e mondiale de l'escrime </h2>\n      <p>La BAFS (Botswana Amateur Fencing Society), en partenariat avec Young Africa Botswana et le KRC (Kalahari Research and Conservation), a c\xE9l\xE9br\xE9 la Journ\xE9e mondiale de l'escrime le samedi 7 septembre. Un certain nombre d'activit\xE9s ont \xE9t\xE9 organis\xE9es sur le th\xE8me \xAB L'escrime pour notre plan\xE8te \xBB, et la BAFS s'est \xE9galement jointe \xE0 ses partenaires du KRC, du D\xE9partement des affaires environnementales et de plusieurs autres organisations pour c\xE9l\xE9brer l'International Vulture Awareness Day (Journ\xE9e internationale de sensibilisation aux vautours), qui se d\xE9roule \xE0 la m\xEAme date annuelle officielle que la Journ\xE9e mondiale de l'escrime. Les tireurs ont d\xE9fil\xE9 dans la ville aux c\xF4t\xE9s de nombreux officiels du gouvernement et d'autres organismes, notamment des repr\xE9sentants du Minist\xE8re de l'Environnement, de la Conservation des ressources naturelles et du Tourisme, de plusieurs ambassades et d'autres organisations. Le maire de la ville de Gaborone et d'autres dignitaires \xE9taient pr\xE9sents et se sont adress\xE9s au public au cours de l'\xE9v\xE9nement.</p>\n      <p>Apr\xE8s la marche de solidarit\xE9, la BAFS s'est rendue au Lady Olebile Masire Youth Centre, qui fait partie des installations du Young Africa Botswana, o\xF9 un mini tournoi d'escrime et des d\xE9monstrations pour le public \xE9taient organis\xE9s pour que chacun puisse d\xE9couvrir \xAB l'esprit de l'escrime en action \xBB, selon un communiqu\xE9 officiel de la BAFS. \xAB La BAFS encourage les athl\xE8tes, les entra\xEEneurs, les clubs d'escrime et les f\xE9d\xE9rations du monde entier \xE0 montrer non seulement leur amour pour l'escrime, mais \xE9galement \xE0 utiliser leurs talents et leur d\xE9vouement envers le sport pour contribuer \xE0 l'\xE9panouissement de leurs communaut\xE9s et am\xE9liorer notre environnement commun \xBB, a ajout\xE9 la BAFS. </p>\n      <p>*Information sur la Journ\xE9e internationale de sensibilsation aux vautours et sur le role important que jouent les vautours dans la biodiversit\xE9 des environments o\xF9 ils habitent sont disponibles sur <a href=\"https://www.vultureday.org\" target=\"_blank\">www.vultureday.org</a></p>\n      \n      <h2>Une vid\xE9o d\u2019escrime de Budapest prim\xE9e \xE0 Cannes</h2>\n      <p>Une vid\xE9o produite \xE0 l\u2019occasion des Championnats du monde d\u2019escrime 2019 de Budapest a remport\xE9 le troph\xE9e du \xAB Dauphin d\u2019argent \xBB lors du festival annuel Cannes Corporate Media & TV Awards. La vid\xE9o, intitul\xE9e \xAB A Kind of Magic \xBB, concourait dans la cat\xE9gorie des M\xE9dias sociaux et courtes vid\xE9os.</p>\n      <p>Cette vid\xE9o, courte et divertissante, a \xE9t\xE9 diffus\xE9e au public de l\u2019escrime dans le BOK Hall de Budapest, o\xF9 les finales devaient se tenir. Elle met en sc\xE8ne le sabreur hongrois Andras Szatmari, champion du monde et personnage principal du film, qui doit faire face \xE0 un magicien lors d\u2019un assaut d\u2019escrime. M. Szatmari \xE9tait pr\xE9sent pour recevoir la r\xE9compense, accompagn\xE9e du directeur du film, M. Ivan Vermes. Au total, 950 productions issues de 51 pays ont \xE9t\xE9 soumises \xE0 la comp\xE9tition internationale de Cannes afin de remporter l\u2019un des 149 troph\xE9es : dauphin d\u2019or, d\u2019argent, noir ou bleu ou encore le tant convoit\xE9 Grand Prix du \xAB Dauphin Blanc \xBB.</p>\n      <p>Le festival Corporate Media & TV Awards de Cannes met chaque ann\xE9e \xE0 l\u2019honneur les \xAB les meilleurs films corporate, films destin\xE9s \xE0 un usage en ligne, documentaires et reportages \xBB. Il s\u2019agit du seul festival d\xE9di\xE9 au film corporate ayant lieu \xE0 Cannes, ville l\xE9gendaire du long m\xE9trage et du film publicitaire. Cette comp\xE9tition, qui f\xEAte ses dix ans, est ouverte aux producteurs de films, clients, agences, cha\xEEnes de t\xE9l\xE9vision et \xE9tudiants. Des informations d\xE9taill\xE9es sur ces r\xE9compenses, y compris une liste compl\xE8te des gagnants et des liens vers les films prim\xE9s sont disponibles <a href=\"https://www.cannescorporate.com/\" target=\"_blank\">ici</a>.</p>\n      <p>La FIE tient \xE0 f\xE9liciter M. Szatmari, M. Vermes et la F\xE9d\xE9ration hongroise d\u2019escrime pour cette splendide r\xE9ussite.</p>\n      \n      \n\n\n\n\n      <h2>Donate Your Fencing Gear! au Paraguay</h2>\n      <p>La F\xE9d\xE9ration paraguayenne d'escrime (FPE), qui fait partie des b\xE9n\xE9ficiaires de la saison d'escrime 2018-2019 du programme Donate Your Fencing Gear! de la FIE, a qualifi\xE9 son ann\xE9e d'entra\xEEnement et de comp\xE9tition de \xAB succ\xE8s \xBB gr\xE2ce, en partie, \xE0 l'utilisation des \xE9quipements re\xE7us en don. L'objectif du programme de la FIE est de collecter aupr\xE8s des tireurs de haut niveau des \xE9quipements d'escrime approuv\xE9s par la FIE qui sont usag\xE9s mais de bonne qualit\xE9, afin de soutenir les tireurs aguerris ou d\xE9butants vivant dans des milieux d\xE9favoris\xE9s aux quatre coins du monde, comme au Paraguay. </p>\n      <p>L'un des crit\xE8res du processus de candidature, la \xAB motivation \xBB, a \xE9t\xE9 d\xE9crit comme suit par la FPE et son chef de projet, Miguel Angel Paredes Fassino : offrir \xAB des alternatives aux jeunes et aux enfants, gar\xE7ons et filles, pour leur permettre de profiter de lieux publics comme les squares et les h\xE9bergements temporaires, tels que ceux accueillant les personnes touch\xE9es par les inondations provoqu\xE9es par la rivi\xE8re R\xEDo Paraguay, et du quartier d'Obrero de la ville d'Asunci\xF3n \xBB. Les autres objectifs cit\xE9s \xE9taient notamment de d\xE9couvrir de nouveaux talents de l'escrime pour le Paraguay, d'\xEAtre \xE0 m\xEAme d'inscrire des athl\xE8tes aux Championnats d'Am\xE9rique du Sud (qui se sont d\xE9roul\xE9s en 2018), et de se pr\xE9parer pour participer \xE0 la comp\xE9tition d'escrime des Jeux d'Am\xE9rique du Sud (ODESUR 2022) qui seront accueillis \xE0 Asunci\xF3n. La ville a \xE9galement jou\xE9 un r\xF4le pr\xE9pond\xE9rant en soutenant \xE9galement la FPE, qui a r\xE9ussi \xE0 faire participer plusieurs de ses athl\xE8tes \xE0 des comp\xE9titions de toute la r\xE9gion.</p>\n      <p>Des entra\xEEnements d'escrime en ext\xE9rieur ont notamment \xE9t\xE9 organis\xE9s tout au long de l'ann\xE9e sur la Plaza Cerro Porteno de la ville de Fernando de la Mora et au Comando de Ingenier\xEDa de la ville d'Asunci\xF3n, \xE0 proximit\xE9 des zones inond\xE9es mentionn\xE9es pr\xE9c\xE9demment. Gr\xE2ce \xE0 l'enseignement des entra\xEEneurs d'escrime, Alessandro Tradori et Juan Antonio Lucas, et aux b\xE9n\xE9fices directs du programme Donate Your Fencing Gear!, des athl\xE8tes de r\xE9gions sp\xE9cifiques manquant de ressources et d'\xE9quipements ont pu s'entra\xEEner r\xE9guli\xE8rement. Plusieurs enfants pratiquant l'escrime ont ainsi pu participer aux championnats nationaux, et remporter des m\xE9dailles de bronze, d'argent et m\xEAme d'or. Le Comit\xE9 Olympique paraguayen a \xE9galement apport\xE9 son soutien en affr\xE9tant des bus deux fois par semaine pour emmener les enfants aux entra\xEEnements. </p>\n      <p>La FPE d\xE9veloppe l'escrime et met actuellement en \u0153uvre des projets similaires dans d'autres villes aux quatre coins du Paraguay. Aux derni\xE8res nouvelles, l'escrime avait fait ses premiers pas dans les villes de Villa Hayes, \xE0 50 km d'Asunci\xF3n, et de Villarrica, \xE0 150 km.  </p>\n\n\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n          <a href=\"https://absolutefencinggear.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:1022px;left:372px;width:484px; height:47px;\"></div>\n          </a>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <a href=\"https://absolutefencinggear.com\" target=\"_blank\">\n          <img src=\"/112/fr/static/_mobile/pg41.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n          <a href=\"http://www.gfencing.com\" target=\"_blank\">\n            <div class=\"contentLinkNone\" style=\"top:728px;left:545px;width:219px; height:28px;\"></div>\n          </a>\n\n          <a href=\"mailto:sales@gfencing.com\">\n            <div class=\"contentLinkNone\" style=\"top:728px;left:765px;width:219px; height:28px;\"></div>\n          </a>\n          ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          }, 1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "",
    "mobileHtml": "\n        <a href=\"http://www.gfencing.com\" target=\"_blank\">\n          <img src=\"/112/fr/static/_mobile/pg42.jpg\">\n        </a>\n      "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n      <img id=\"43-title\" class=\"halfScale\" style=\"top:50px;left:83px\" src=\"/112/fr/static/_content/43-title.png\">\n\n      <img id=\"43-pop-1\" class=\"halfScale 43-pop\" style=\"top:390px;left:84px;\" src=\"/112/fr/static/_content/43-pop-1.png\">\n      <img id=\"43-pop-2\" class=\"halfScale 43-pop\" style=\"top:390px;left:84px;opacity:0\" src=\"/112/fr/static/_content/43-pop-2.png\">\n      <img id=\"43-pop-3\" class=\"halfScale 43-pop\" style=\"top:390px;left:84px;opacity:0\" src=\"/112/fr/static/_content/43-pop-3.png\">\n      \n      <img class=\"halfScale pointer 43-btn\" id=\"43-btn-1\" style=\"top:454px;left:1135px;\" onclick=\"pg43Toggle('43-pop-1', '43-btn-1');\" src=\"/112/fr/static/_content/43-btn-1.png\">\n      <img class=\"halfScale pointer 43-btn\" id=\"43-btn-2\" style=\"top:595px;left:1135px;opacity:0\" onclick=\"pg43Toggle('43-pop-2', '43-btn-2');\" src=\"/112/fr/static/_content/43-btn-2.png\">\n      <img class=\"halfScale pointer 43-btn\" id=\"43-btn-3\" style=\"top:730px;left:1135px;opacity:0\" onclick=\"pg43Toggle('43-pop-3', '43-btn-3');\" src=\"/112/fr/static/_content/43-btn-3.png\">\n\n      <div class=\"addContentLink\" style=\"bottom:5px;right:70px;width:130px; height:30px;\">\n        <a href=\"http://www.fie.org\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg43Anim = new TimelineMax()\n        pg43Anim\n          .fromTo(idOf(\"43-title\"), 0.5,{y:-100, opacity:0, }, {y:0, opacity:1, onComplete: addContentLinks},0.5)\n      }\n\n      function pg43Toggle(id, btn) {\n        var ele = idOf(id)\n        var but = idOf(btn)\n        TweenMax.to(cOf(\"43-pop\"), 0.1, {opacity: 0});\n        TweenMax.to(cOf(\"43-btn\"), 0.1, {opacity: 0});\n        TweenMax.to(ele, 0.1, {opacity: 1});\n        TweenMax.to(but, 0.1, {opacity: 1});\n      }\n\n      function onPageLeave() {\n        pg43Anim.stop();\n        pg43Toggle(\"43-pop-1\", \"43-btn-1\");\n        removeContentLinks();\n      }\n      ",
    "searchText": "NÉCROLO GIE  NÉCROLOGIES GREGORIO LIMA (PUR) C’est avec une grande tristesse que la FIE vous fait part du décès de Gregorio Lima ce 25 juillet à San Juan, Porto Rico, à l’âge de 80 ans. M. Lima était membre du Conseil des vétérans de la FIE depuis 2016. Membre de la Fédération portoricaine d’escrime depuis 1980, il y a assumé les fonctions de vice-président pendant 25 ans et de président de 2010 à 2017. Il était avocat de profession et titulaire d’un doctorat en droit. La FIE et la famille mondiale de l’escrime ont perdu l’un de leurs membres, apprécié et respecté de tous. M. Lima n’a jamais cessé de donner le meilleur  de lui-même, consacrant toute son énergie à la cause de notre sport. Leader extraordinaire, il a fortement contribué au développement de l’escrime. Nous présentons nos plus sincères condoléances à sa famille et à ses amis, ainsi qu’à la Fédération portoricaine d’escrime, et nous les assurons de notre profonde sympathie dans ces moments difficiles. ■  GREGORIO LIMA  SHLOMI EYAL  UWE NEDER  s Cliquez ici  W W W.FIE .ORG",
    "mobileHtml": "\n      \n      \n      \n      \n      \n      L'arbitre allemand Uwe Neder est d\xE9c\xE9d\xE9 subitement fin octobre \xE0 l'\xE2ge de 54 ans. \n\n      Neder a d\xE9couvert l'escrime en tant que \xAB p\xE8re d'escrimeuses \xBB, puisqu'il amenait ses filles aux entra\xEEnements et aux comp\xE9titions. Il a rapidement souhait\xE9 s'impliquer davantage et a commenc\xE9 en 2001 sa formation d'arbitre. Neder est devenu un arbitre accompli \xE0 la fois au niveau national et international, et a notamment offici\xE9 lors des Jeux Mondiaux Militaires 2015 en Cor\xE9e du Sud, sa comp\xE9tition la plus importante. En 2016, il a \xE9t\xE9 \xE9lu \xAB Arbitre \xE0 l'\xE9p\xE9e de l'ann\xE9e \xBB par la F\xE9d\xE9ration allemande d'escrime.\n      Au-del\xE0 de l'arbitrage, Neder \xE9tait tr\xE8s impliqu\xE9 dans le club d'escrime de sa ville, le FC Offenbach, notamment en tant qu'organisateur de tournois. \n      \n      Cette personnalit\xE9 amicale et charismatique de l'escrime va manquer \xE0 tous les membres de son club, mais \xE9galement aux communaut\xE9s de l'escrime allemande et internationale.\n      \n      \n\n      \n\n      <p><strong>Gregorio Lima (PUR)</strong></p>\n      <p>C'est avec une grande tristesse que la FIE vous fait part du d\xE9c\xE8s de Gregorio Lima ce 25 juillet \xE0 San Juan, Porto Rico, \xE0 l'\xE2ge de 80 ans. </p>\n      <p>M. Lima \xE9tait membre du Conseil des v\xE9t\xE9rans de la FIE depuis 2016. Membre de la F\xE9d\xE9ration portoricaine d'escrime depuis 1980, il y a assum\xE9 les fonctions de vice-pr\xE9sident pendant 25 ans et de pr\xE9sident de 2010 \xE0 2017. Il \xE9tait avocat de profession et titulaire d'un doctorat en droit. </p>\n      <p>La FIE et la famille mondiale de l'escrime ont perdu l'un de leurs membres, appr\xE9ci\xE9 et respect\xE9 de tous. M. Lima n'a jamais cess\xE9 de donner le meilleur de lui-m\xEAme, consacrant toute son \xE9nergie \xE0 la cause de notre sport. Leader extraordinaire, il a fortement contribu\xE9 au d\xE9veloppement de l'escrime. </p>\n      <p>Nous pr\xE9sentons nos plus sinc\xE8res condol\xE9ances \xE0 sa famille et \xE0 ses amis, ainsi qu'\xE0 la F\xE9d\xE9ration portoricaine d'escrime, et nous les assurons de notre profonde sympathie dans ces moments difficiles. </p>\n\n      <p><strong>Shlomi Eyal (ISR)</strong></p>\n      <p>La FIE a la tristesse de vous faire part du d\xE9c\xE8s de M. Shlomi Eyal, n\xE9 le 20 juin 1959. M. Eyal a repr\xE9sent\xE9 Isra\xEBl aux Jeux Olympiques en 1984, et est ensuite devenu entra\xEEneur aux \xC9tats-Unis. En 1988, il est revenu en Isra\xEBl o\xF9 il a cr\xE9\xE9 un club d'escrime au kibboutz Yizrael. Au cours de ses nombreuses ann\xE9es consacr\xE9es \xE0 l'escrime, il a form\xE9 plusieurs athl\xE8tes d'\xE9lite et a assum\xE9 la fonction d'entra\xEEneur national. </p>\n      <p>Au nom de la famille mondiale de l'escrime, la FIE pr\xE9sente ses plus sinc\xE8res condol\xE9ances \xE0 sa famille, \xE0 ses amis et \xE0 la F\xE9d\xE9ration isra\xE9lienne d'escrime.</p>\n\n      <p><strong>Uwe Neder (GER)</strong></p>\n      <p>L'arbitre allemand Uwe Neder est d\xE9c\xE9d\xE9 subitement fin octobre \xE0 l'\xE2ge de 54 ans. </p>\n      <p>Neder a d\xE9couvert l'escrime en tant que \xAB p\xE8re d'escrimeuses \xBB, puisqu'il amenait ses filles aux entra\xEEnements et aux comp\xE9titions. Il a rapidement souhait\xE9 s'impliquer davantage et a commenc\xE9 en 2001 sa formation d'arbitre. Neder est devenu un arbitre accompli \xE0 la fois au niveau national et international, et a notamment offici\xE9 lors des Jeux Mondiaux Militaires 2015 en Cor\xE9e du Sud, sa comp\xE9tition la plus importante. En 2016, il a \xE9t\xE9 \xE9lu \xAB Arbitre \xE0 l'\xE9p\xE9e de l'ann\xE9e \xBB par la F\xE9d\xE9ration allemande d'escrime.</p>\n      <p>Au-del\xE0 de l'arbitrage, Neder \xE9tait tr\xE8s impliqu\xE9 dans le club d'escrime de sa ville, le FC Offenbach, notamment en tant qu'organisateur de tournois. </p>\n      <p> Cette personnalit\xE9 amicale et charismatique de l'escrime va manquer \xE0 tous les membres de son club, mais \xE9galement aux communaut\xE9s de l'escrime allemande et internationale.</p>\n\n      "
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function toggleCategory(id, klass) {\n        var category = idOf(id);\n        console.log(category)\n        var categories = cOf(klass);\n        console.log(categories)\n        for(i=0; i < categories.length; i++){\n          categories[i].style.opacity = 0;\n        }\n        category.style.opacity = 1;\n      }\n    ",
  "mobilePages": [{
    "title": "Escrime XXI No. 112",
    "cssClass": "cover mobile-p1",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 0,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 2,
      "subIndex": 0
    }]
  }, {
    "title": "Comex",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 4,
      "subIndex": 0
    }]
  }, {
    "title": "Sommaire",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 5,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 6,
      "subIndex": 0
    }]
  }, {
    "title": "Championnats du monde d'escrime vétérans",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 7,
      "subIndex": 0
    }, {
      "index": 8,
      "subIndex": 0
    }, {
      "index": 9,
      "subIndex": 0
    }]
  }, {
    "title": "IWAS",
    "cssClass": "red",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 10,
      "subIndex": 0
    }, {
      "index": 11,
      "subIndex": 0
    }, {
      "index": 12,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 13,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 14,
      "subIndex": 0
    }]
  }, {
    "title": "À LA RENCONTRE DES SPORTIFS: Sofia Velikaya",
    "cssClass": "aqua",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 15,
      "subIndex": 0
    }, {
      "index": 16,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 17,
      "subIndex": 0
    }]
  }, {
    "title": "Journée mondiale de l'escrime",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 18,
      "subIndex": 0
    }, {
      "index": 19,
      "subIndex": 0
    }, {
      "index": 20,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 21,
      "subIndex": 0
    }]
  }, {
    "title": "Journée mondiale de l'escrime - Siège social de la FIE",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 22,
      "subIndex": 0
    }, {
      "index": 23,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 24,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 25,
      "subIndex": 0
    }]
  }, {
    "title": "Jeux Panaméricains",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 26,
      "subIndex": 0
    }, {
      "index": 27,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 28,
      "subIndex": 0
    }]
  }, {
    "title": "La ville de Guatemala célèbre la Journée mondiale de l'escrime",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 29,
      "subIndex": 0
    }, {
      "index": 30,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 31,
      "subIndex": 0
    }]
  }, {
    "title": "CAMP D’ENTRAINEMENT DE LA FIE A BUDAPEST",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 32,
      "subIndex": 0
    }, {
      "index": 33,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 34,
      "subIndex": 0
    }]
  }, {
    "title": "Solidarité Olympique - Cours pour entraîneurs",
    "cssClass": "green",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 35,
      "subIndex": 0
    }, {
      "index": 36,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 37,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 38,
      "subIndex": 0
    }]
  }, {
    "title": "FIE ACTUALITÉS",
    "cssClass": "yellow",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 39,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 40,
      "subIndex": 0
    }]
  }, {
    "title": "Advert",
    "cssClass": "advert",
    "hideInMenu": true,
    "pageLinks": [{
      "index": 41,
      "subIndex": 0
    }]
  }, {
    "title": "Nécrologie",
    "cssClass": "grey",
    "hideInMenu": false,
    "pageLinks": [{
      "index": 42,
      "subIndex": 0
    }]
  }],
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-137252729-38',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SU9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bMw6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.01c215ae7a9edc1c6e1c.js